/* eslint-disable @atlassian/i18n/no-literal-string-in-jsx */
import React, { type FunctionComponent } from 'react';
import { useIntl } from 'react-intl-next';

import { messages } from '../i18n/messages.ts';
import { messages as okrTrackerMessages } from '../i18n/okr-tracker-messages.ts';

import { tagBackgroundColors, tagBorderColors, templateStyles } from './styles.ts';

const OkrTracker: FunctionComponent = () => {
  const { formatMessage } = useIntl();

  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={348} height={142} fill="none">
      <rect width={336} height={142} fill={templateStyles['background']} rx={3} />
      <rect
        width={76}
        height={95}
        x={4}
        y={4}
        fill={templateStyles['boardBackground']}
        rx={0.93}
      />
      <rect
        width={18.69}
        height={5.92}
        x={6.65}
        y={7.89}
        fill={tagBackgroundColors['redLight']}
        rx={0.78}
      />
      <rect
        width={18.69}
        height={5.92}
        x={6.65}
        y={7.89}
        stroke={tagBorderColors['redLight']}
        strokeWidth={0.31}
        rx={0.78}
      />
      <text
        xmlSpace="preserve"
        fill={templateStyles['fontColor']}
        fontFamily={templateStyles['fontFamily']}
        fontSize={4.36}
        letterSpacing="0em"
        style={{
          whiteSpace: 'pre'
        }}
      >
        <tspan x={8.9} y={12.01}>
          {formatMessage(okrTrackerMessages['okr-tracker.field-4-select-option-1'])}
        </tspan>
      </text>
      <g filter="url(#okrTracker-a)">
        <rect
          width={71.02}
          height={64.14}
          x={6.49}
          y={17.7}
          fill={templateStyles['background']}
          rx={1.25}
        />
        <text
          xmlSpace="preserve"
          fill={templateStyles['fontColor']}
          fontFamily={templateStyles['fontFamily']}
          fontSize={4.98}
          fontWeight="bold"
          letterSpacing="0em"
          style={{
            whiteSpace: 'pre'
          }}
        >
          <tspan x={8.98} y={26.32}>
            {formatMessage(okrTrackerMessages['okr-tracker.entry-1-cell-2']).substring(
              0,
              23
            )}
          </tspan>
          <tspan x={8.98} y={32.55}>
            {formatMessage(okrTrackerMessages['okr-tracker.entry-1-cell-2']).substring(
              23,
              43
            )}
          </tspan>
          <tspan x={8.98} y={38.78}>
            {formatMessage(okrTrackerMessages['okr-tracker.entry-1-cell-2']).substring(
              43
            )}
          </tspan>
        </text>
        <text
          xmlSpace="preserve"
          fill={templateStyles['fontColor']}
          fontFamily={templateStyles['fontFamily']}
          fontSize={4.36}
          letterSpacing="0em"
          style={{
            whiteSpace: 'pre'
          }}
        >
          <tspan x={8.98} y={47.59}>
            {'0%'}
          </tspan>
        </text>
        <rect
          width={31.72}
          height={8.25}
          x={8.98}
          y={52.42}
          fill={templateStyles['userBackground']}
          rx={4.12}
        />
        <path
          fill={templateStyles['icon']}
          fillRule="evenodd"
          d="M12.72 54.52a2.02 2.02 0 1 0 1.01 3.78l.23.4a2.5 2.5 0 1 1 1.25-2.16c0 .27-.09.56-.25.79a.96.96 0 0 1-.79.41.69.69 0 0 1-.66-.44c-.36.42-.94.6-1.41.32-.56-.32-.65-1.06-.32-1.62.32-.56 1.01-.85 1.56-.54a1.07 1.07 0 0 1 .5 1.01c0 .22.02.44.08.6.03.08.06.13.1.16.03.03.07.05.15.05a.5.5 0 0 0 .4-.23.9.9 0 0 0 .17-.5c0-1.12-.9-2.03-2.02-2.03Zm.66 1.9c0-.25-.1-.45-.27-.55-.27-.16-.7-.04-.93.36-.23.4-.12.83.15.99.27.15.7.04.93-.37a.92.92 0 0 0 .12-.4v-.03Z"
          clipRule="evenodd"
        />
        <path
          fill={templateStyles['fontColor']}
          d="M16.85 58.04v-3.07h1.17c.2 0 .37.04.52.12.14.07.26.18.34.31.08.14.12.3.12.49 0 .21-.05.4-.16.55a.85.85 0 0 1-.46.33l.71 1.27h-.45L18 56.83h-.76v1.21h-.38Zm.38-1.55H18c.2 0 .35-.05.45-.15.11-.1.16-.25.16-.44a.56.56 0 0 0-.16-.43.66.66 0 0 0-.47-.16h-.74v1.18Zm3.3 1.6c-.22 0-.4-.05-.57-.15a.96.96 0 0 1-.36-.4 1.45 1.45 0 0 1-.13-.64c0-.25.04-.46.13-.64.08-.18.2-.31.36-.4.16-.1.35-.15.57-.15.22 0 .4.05.56.14.16.1.28.23.37.41.08.18.13.39.13.63 0 .25-.05.46-.13.64a.95.95 0 0 1-.93.55Zm0-.33c.14 0 .27-.04.37-.1.1-.07.17-.17.23-.3.05-.13.08-.28.08-.46 0-.19-.03-.34-.08-.47a.62.62 0 0 0-.23-.3.64.64 0 0 0-.37-.1.64.64 0 0 0-.37.1.63.63 0 0 0-.23.3c-.05.13-.08.28-.08.46 0 .19.03.34.08.47.05.13.13.23.23.3.1.06.22.1.37.1Zm2.77.32c-.1 0-.2-.01-.3-.04a.78.78 0 0 1-.42-.36h-.03v.36h-.37v-3.2h.37v1.27h.04c.04-.08.1-.15.17-.21a.86.86 0 0 1 .54-.19c.2 0 .37.05.5.15.15.1.27.23.34.4.08.19.12.4.12.63 0 .25-.04.46-.12.63a.96.96 0 0 1-.33.42.88.88 0 0 1-.5.14Zm-.08-.32c.14 0 .26-.04.36-.1.1-.08.17-.17.22-.3.06-.13.09-.28.09-.46s-.03-.34-.09-.47a.64.64 0 0 0-.22-.29.61.61 0 0 0-.36-.1.62.62 0 0 0-.36.1.66.66 0 0 0-.23.3c-.06.12-.09.28-.09.45 0 .18.03.34.09.47.05.12.13.22.23.3.1.06.22.1.36.1Zm1.63.28v-2.3h.37v2.3h-.37Zm.18-2.73a.25.25 0 0 1-.18-.08.25.25 0 0 1-.07-.18c0-.07.02-.13.07-.18a.25.25 0 0 1 .18-.07.25.25 0 0 1 .26.26.25.25 0 0 1-.26.26Zm2.16 2.73v-3.07h.38v2.73h1.48v.34H27.2Zm3.27.04c-.22 0-.4-.04-.57-.14a.96.96 0 0 1-.36-.4 1.45 1.45 0 0 1-.13-.64c0-.25.04-.46.13-.64.08-.18.2-.31.36-.4.16-.1.35-.15.57-.15.21 0 .4.05.56.14.16.1.28.23.36.41.1.18.13.39.13.63 0 .25-.04.46-.13.64a.95.95 0 0 1-.92.55Zm0-.32c.14 0 .26-.04.36-.1.1-.07.18-.17.23-.3.06-.13.09-.28.09-.46 0-.19-.03-.34-.09-.47a.62.62 0 0 0-.23-.3.64.64 0 0 0-.36-.1.64.64 0 0 0-.37.1.63.63 0 0 0-.23.3c-.06.13-.08.28-.08.46 0 .19.02.34.08.47.05.13.13.23.23.3.1.06.22.1.37.1Zm1.63 1.05v-3.06h.37v.37h.03a.75.75 0 0 1 .42-.36c.1-.04.2-.05.3-.05.2 0 .36.05.5.15.15.1.26.23.34.41.08.18.12.39.12.62 0 .25-.04.46-.12.63a.96.96 0 0 1-.33.42.88.88 0 0 1-.51.14.85.85 0 0 1-.54-.19.69.69 0 0 1-.18-.2h-.03v1.12h-.37Zm1.03-1.05c.14 0 .26-.04.36-.1.1-.08.18-.17.23-.3.06-.13.08-.28.08-.46s-.02-.34-.08-.47a.64.64 0 0 0-.23-.29.61.61 0 0 0-.36-.1.62.62 0 0 0-.36.1.66.66 0 0 0-.23.3c-.05.12-.08.28-.08.45 0 .18.03.34.08.47.06.12.13.22.23.3.1.06.22.1.36.1Zm2.57.32c-.22 0-.41-.04-.57-.14a.96.96 0 0 1-.36-.4 1.45 1.45 0 0 1-.12-.64c0-.23.04-.44.12-.62a1 1 0 0 1 .36-.42c.16-.1.34-.15.54-.15.21 0 .4.05.54.14.15.1.27.23.34.4.09.18.13.38.13.6V57h-1.84v-.3h1.65l-.19.28v-.15c0-.18-.02-.33-.08-.44a.57.57 0 0 0-.55-.35.61.61 0 0 0-.33.09.62.62 0 0 0-.23.27 1 1 0 0 0-.09.43v.15c0 .16.03.3.09.42a.62.62 0 0 0 .6.35c.1 0 .19-.01.27-.04a.6.6 0 0 0 .19-.1.4.4 0 0 0 .1-.14v-.02h.38v.02a.7.7 0 0 1-.11.22.85.85 0 0 1-.48.34c-.1.04-.23.05-.36.05Zm1.5-.04v-.26l1.32-1.7v-.02H37.2v-.31h1.76v.27l-1.32 1.68v.04h1.32v.3H37.2Z"
        />
        <rect
          width={9.69}
          height={5.92}
          x={9.14}
          y={63.31}
          fill={tagBackgroundColors['yellow']}
          rx={0.78}
        />
        <rect
          width={9.69}
          height={5.92}
          x={9.14}
          y={63.31}
          stroke={tagBorderColors['yellow']}
          strokeWidth={0.31}
          rx={0.78}
        />
        <text
          xmlSpace="preserve"
          fill={templateStyles['fontColor']}
          fontFamily={templateStyles['fontFamily']}
          fontSize={4.36}
          letterSpacing="0em"
          style={{
            whiteSpace: 'pre'
          }}
        >
          <tspan x={10.99} y={67.44}>
            {formatMessage(okrTrackerMessages['okr-tracker.field-5-select-option-1'])}
          </tspan>
        </text>
        <g clipPath="url(#okrTracker-b)">
          <rect
            width={66.04}
            height={6.23}
            x={8.98}
            y={71.88}
            fill={templateStyles['background']}
            rx={0.93}
          />
          <path fill={templateStyles['background']} d="M9.92 72.81h4.36v4.36H9.92z" />
          <path
            fill={templateStyles['link']}
            d="M11.5 74.9c-.05-.05-.11-.05-.14.01l-.7 1.41a.08.08 0 0 0 .07.12h.98a.08.08 0 0 0 .08-.04c.2-.44.08-1.1-.3-1.5Zm.52-1.29c-.4.63-.37 1.32-.11 1.84l.47.95c.01.03.04.04.08.04h.98a.08.08 0 0 0 .07-.12l-1.35-2.7c-.03-.07-.1-.07-.14 0ZM15.6 76.88V73.8H16v1.33h1.68V73.8h.38v3.08h-.38v-1.4H16v1.4h-.39Zm4.13.04c-.21 0-.4-.05-.56-.15a.97.97 0 0 1-.37-.4 1.45 1.45 0 0 1-.12-.64c0-.25.04-.46.12-.64.09-.17.21-.31.37-.4.16-.1.35-.15.56-.15.22 0 .41.05.57.14.16.1.28.24.36.41.09.18.13.4.13.64 0 .25-.04.46-.13.63a.95.95 0 0 1-.93.56Zm0-.33c.15 0 .27-.03.37-.1.1-.07.18-.17.23-.3.06-.12.08-.28.08-.46s-.02-.34-.08-.47a.62.62 0 0 0-.23-.29.64.64 0 0 0-.37-.1.64.64 0 0 0-.36.1.63.63 0 0 0-.24.3c-.05.12-.08.28-.08.46s.03.34.08.46c.06.13.13.23.24.3.1.07.22.1.36.1Zm2 .29-.65-2.3h.37l.45 1.84h.04l.51-1.84h.35l.51 1.84h.04l.45-1.84h.37l-.64 2.3h-.38l-.51-1.78h-.03l-.52 1.78h-.37Zm5.5.07c-.3 0-.56-.07-.77-.2a1.3 1.3 0 0 1-.48-.56 2 2 0 0 1-.17-.85c0-.33.06-.62.17-.86.12-.24.28-.42.49-.55.21-.13.46-.2.75-.2.3 0 .54.07.75.2.21.13.38.31.49.56.11.24.17.52.17.85 0 .33-.06.61-.17.85a1.28 1.28 0 0 1-1.24.76Zm0-.35c.2 0 .38-.06.53-.16a1 1 0 0 0 .35-.44c.09-.18.13-.4.13-.66s-.04-.48-.13-.67a.99.99 0 0 0-.35-.43.95.95 0 0 0-.54-.15c-.2 0-.39.05-.54.15a1 1 0 0 0-.35.43c-.09.2-.13.41-.13.67 0 .25.04.48.12.66.09.2.2.34.35.44.16.1.34.16.55.16Zm2.02 1.04v-3.06h.37v.37h.03a.76.76 0 0 1 .42-.36c.1-.03.19-.05.3-.05.2 0 .36.05.5.15.15.1.26.24.34.41.08.18.12.39.12.63s-.04.45-.12.63a.96.96 0 0 1-.34.41.88.88 0 0 1-.5.15.85.85 0 0 1-.55-.19.69.69 0 0 1-.17-.22h-.03v1.13h-.37Zm1.03-1.05c.14 0 .26-.03.36-.1.1-.07.18-.17.23-.3.05-.13.08-.28.08-.46s-.03-.34-.08-.46a.64.64 0 0 0-.23-.3.61.61 0 0 0-.36-.1.62.62 0 0 0-.36.1.66.66 0 0 0-.23.3c-.05.13-.08.28-.08.46s.03.33.08.46.13.23.23.3c.1.06.22.1.36.1Zm2.42.33c-.17 0-.33-.03-.46-.08a.79.79 0 0 1-.31-.22.6.6 0 0 1-.14-.33h.38c.03.1.1.17.18.23.1.06.21.09.36.09.1 0 .2-.02.27-.05a.47.47 0 0 0 .19-.12.28.28 0 0 0 .07-.19.25.25 0 0 0-.1-.2.72.72 0 0 0-.3-.13l-.36-.09a1.3 1.3 0 0 1-.35-.13.55.55 0 0 1-.2-.2.59.59 0 0 1-.07-.29c0-.13.03-.24.1-.34.08-.1.19-.18.31-.24.13-.06.28-.09.44-.09.16 0 .3.03.43.08.12.05.22.12.3.21.07.1.12.2.14.33h-.37a.38.38 0 0 0-.16-.22.6.6 0 0 0-.34-.09c-.1 0-.17.02-.24.04a.4.4 0 0 0-.17.12.28.28 0 0 0-.06.18c0 .06 0 .1.04.14.02.04.07.08.12.1.06.04.13.06.22.09l.35.08c.22.05.38.13.49.23.1.1.16.23.16.4 0 .13-.05.25-.13.36a.8.8 0 0 1-.33.24c-.13.06-.29.09-.46.09Zm2.44.77c-.19 0-.35-.03-.49-.08a.79.79 0 0 1-.33-.22.65.65 0 0 1-.15-.33h.39c.02.09.08.16.18.21.1.06.23.09.4.09.2 0 .36-.05.48-.14.11-.1.17-.23.17-.4v-.46h-.03a.78.78 0 0 1-.72.4.92.92 0 0 1-.52-.14.94.94 0 0 1-.33-.4 1.33 1.33 0 0 1-.11-.57c0-.21.03-.4.11-.57.08-.17.2-.3.34-.4.14-.09.32-.14.52-.14.1 0 .2.02.3.05.08.04.16.08.23.15a.8.8 0 0 1 .18.22h.03v-.38h.37v2.26a.8.8 0 0 1-.48.74c-.16.07-.34.1-.54.1Zm-.02-1.26c.14 0 .26-.03.36-.1.1-.07.18-.16.24-.27a.93.93 0 0 0 .08-.4v-.01a.94.94 0 0 0-.08-.4.64.64 0 0 0-.24-.28.64.64 0 0 0-.36-.1.63.63 0 0 0-.36.1.64.64 0 0 0-.23.28 1 1 0 0 0-.08.4 1 1 0 0 0 .08.4c.05.12.13.21.23.28.1.07.22.1.36.1Zm2.66.49c-.22 0-.4-.05-.56-.15a.96.96 0 0 1-.36-.4 1.45 1.45 0 0 1-.13-.63c0-.24.04-.45.13-.63a1 1 0 0 1 .36-.42c.15-.1.33-.15.54-.15a.93.93 0 0 1 .88.55c.08.17.12.37.12.6v.15h-1.84v-.3h1.65l-.18.27v-.15c0-.18-.03-.33-.08-.44a.57.57 0 0 0-.55-.35.62.62 0 0 0-.33.1.62.62 0 0 0-.23.26 1 1 0 0 0-.09.43v.15c0 .16.03.3.08.42a.62.62 0 0 0 .6.36c.1 0 .2-.02.27-.05a.6.6 0 0 0 .2-.1.4.4 0 0 0 .1-.14v-.02h.37v.02a.7.7 0 0 1-.1.23.85.85 0 0 1-.2.2 1 1 0 0 1-.28.14c-.11.03-.23.05-.37.05Zm1.56-.04v-2.3h.37v.35h.03a.65.65 0 0 1 .25-.29c.11-.06.25-.1.42-.1.26 0 .46.08.6.22.13.15.2.36.2.63v1.49h-.37v-1.4c0-.2-.04-.36-.13-.46-.09-.1-.22-.15-.4-.15a.62.62 0 0 0-.32.08.54.54 0 0 0-.21.22.77.77 0 0 0-.07.35v1.36h-.37Zm2.55 0v-2.3h.37v2.3h-.37Zm.19-2.74a.25.25 0 0 1-.18-.08.25.25 0 0 1-.08-.18c0-.07.03-.13.08-.18a.25.25 0 0 1 .18-.07.25.25 0 0 1 .26.26c0 .06-.03.12-.08.17a.25.25 0 0 1-.18.08Zm1.82 2.78c-.22 0-.41-.05-.57-.15a.96.96 0 0 1-.36-.4 1.45 1.45 0 0 1-.12-.63c0-.24.04-.45.12-.63a1 1 0 0 1 .36-.42c.16-.1.34-.15.54-.15a.93.93 0 0 1 .88.55c.09.17.13.37.13.6v.15h-1.84v-.3h1.65l-.19.27v-.15c0-.18-.02-.33-.08-.44a.57.57 0 0 0-.55-.35.62.62 0 0 0-.33.1.62.62 0 0 0-.23.26 1 1 0 0 0-.09.43v.15c0 .16.03.3.09.42a.62.62 0 0 0 .6.36c.1 0 .19-.02.27-.05a.6.6 0 0 0 .19-.1.4.4 0 0 0 .1-.14v-.02h.38v.02a.7.7 0 0 1-.11.23.85.85 0 0 1-.2.2 1 1 0 0 1-.28.14c-.1.03-.23.05-.36.05Zm3.4 0a.9.9 0 0 1-.38-.09.67.67 0 0 1-.28-.23.65.65 0 0 1-.1-.36.6.6 0 0 1 .1-.36c.06-.1.16-.17.28-.23.13-.05.28-.09.46-.1l.84-.05v.3l-.8.05a.7.7 0 0 0-.38.1.32.32 0 0 0-.12.27c0 .12.04.21.13.28.09.06.2.1.33.1s.24-.03.34-.08c.1-.05.17-.12.23-.2a.52.52 0 0 0 .09-.3v-.71c0-.15-.05-.25-.13-.33-.09-.07-.22-.11-.39-.11a.68.68 0 0 0-.34.07.36.36 0 0 0-.18.21h-.37a.61.61 0 0 1 .15-.32.8.8 0 0 1 .32-.21c.12-.05.27-.08.43-.08.19 0 .35.03.48.1.13.05.23.14.3.26.06.11.1.25.1.4v1.58h-.37v-.34H48a.78.78 0 0 1-.4.33.91.91 0 0 1-.3.05Zm2.72 0a.98.98 0 0 1-.92-.56 1.44 1.44 0 0 1-.13-.64c0-.24.04-.45.13-.62a.97.97 0 0 1 .92-.56c.18 0 .35.03.48.1a.85.85 0 0 1 .48.63v.01h-.37a.53.53 0 0 0-.2-.3.62.62 0 0 0-.4-.11.61.61 0 0 0-.58.4c-.06.13-.08.28-.08.45 0 .18.02.33.08.46a.6.6 0 0 0 .59.4c.15 0 .28-.02.38-.1.1-.06.17-.15.2-.28l.01-.02h.37v.03a.98.98 0 0 1-.17.36.82.82 0 0 1-.32.26c-.13.06-.28.09-.47.09Zm1.52-.04v-3.2h.37v1.25h.04a.65.65 0 0 1 .25-.29c.1-.06.25-.1.42-.1.17 0 .31.03.43.1s.21.16.27.29c.07.13.1.28.1.46v1.49h-.37v-1.4c0-.2-.05-.36-.13-.46-.09-.1-.23-.15-.4-.15a.62.62 0 0 0-.33.08.54.54 0 0 0-.2.22.77.77 0 0 0-.08.35v1.36h-.37Zm2.56 0v-2.3h.37v2.3h-.37Zm.18-2.74a.25.25 0 0 1-.18-.08.25.25 0 0 1-.07-.18c0-.07.02-.13.07-.18a.25.25 0 0 1 .18-.07.25.25 0 0 1 .26.26.25.25 0 0 1-.26.26Zm1.82 2.78c-.22 0-.4-.05-.56-.15a.96.96 0 0 1-.36-.4 1.45 1.45 0 0 1-.13-.63c0-.24.04-.45.13-.63a1 1 0 0 1 .36-.42c.15-.1.33-.15.54-.15a.93.93 0 0 1 .88.55c.08.17.12.37.12.6v.15h-1.84v-.3h1.65l-.18.27v-.15c0-.18-.03-.33-.08-.44a.57.57 0 0 0-.55-.35.62.62 0 0 0-.33.1.62.62 0 0 0-.23.26 1 1 0 0 0-.09.43v.15c0 .16.03.3.08.42a.62.62 0 0 0 .6.36c.1 0 .2-.02.27-.05a.6.6 0 0 0 .2-.1.4.4 0 0 0 .1-.14v-.02h.37v.02a.7.7 0 0 1-.1.23.85.85 0 0 1-.2.2 1 1 0 0 1-.28.14c-.11.03-.23.05-.37.05Zm2.16-.04-.85-2.3h.4l.62 1.9h.04l.63-1.9h.39l-.85 2.3h-.38Zm2.57.04c-.22 0-.4-.05-.57-.15a.96.96 0 0 1-.36-.4 1.45 1.45 0 0 1-.12-.63c0-.24.04-.45.12-.63a1 1 0 0 1 .36-.42c.16-.1.34-.15.55-.15a.93.93 0 0 1 .88.55c.08.17.12.37.12.6v.15h-1.84v-.3h1.65l-.18.27v-.15c0-.18-.03-.33-.09-.44a.57.57 0 0 0-.55-.35.61.61 0 0 0-.33.1.62.62 0 0 0-.23.26 1 1 0 0 0-.08.43v.15c0 .16.02.3.08.42a.62.62 0 0 0 .6.36c.1 0 .2-.02.27-.05a.6.6 0 0 0 .19-.1.4.4 0 0 0 .1-.14l.01-.02h.37v.02a.7.7 0 0 1-.11.23.85.85 0 0 1-.2.2 1 1 0 0 1-.28.14c-.1.03-.23.05-.36.05Zm2.4 0a.88.88 0 0 1-.84-.56 1.53 1.53 0 0 1-.12-.63c0-.24.04-.45.12-.63.08-.18.19-.31.33-.41.15-.1.32-.15.51-.15a.85.85 0 0 1 .54.2c.08.05.13.12.17.2h.04v-1.27h.37v3.2h-.37v-.36h-.03a.78.78 0 0 1-.42.36.87.87 0 0 1-.3.05Zm.08-.33c.14 0 .26-.04.36-.1.1-.07.18-.17.24-.3.05-.13.08-.28.08-.46s-.03-.33-.08-.46a.66.66 0 0 0-.24-.3.62.62 0 0 0-.36-.1.62.62 0 0 0-.35.1.65.65 0 0 0-.23.3 1.2 1.2 0 0 0-.08.46c0 .18.02.33.08.46.05.13.13.23.23.3.1.07.22.1.35.1Zm3.98-2.86c.14 0 .28.03.41.08a1 1 0 0 1 .38.27c.1.12.2.28.27.47.06.2.1.44.1.73 0 .36-.05.66-.15.9-.09.25-.22.44-.4.57-.18.13-.39.2-.64.2-.17 0-.32-.03-.46-.1a.96.96 0 0 1-.54-.66v-.02h.38v.02c.04.08.08.16.14.22a.6.6 0 0 0 .2.15c.1.03.18.05.29.05.18 0 .34-.06.45-.17.12-.1.2-.25.26-.43a2.2 2.2 0 0 0 .1-.65v-.05l-.1-.52a.72.72 0 0 0-.34-.62.64.64 0 0 0-.35-.1.7.7 0 0 0-.7.71c.01.14.04.26.1.37a.67.67 0 0 0 .6.34c.13 0 .25-.03.35-.1a.67.67 0 0 0 .35-.6h.12v.56h-.07a.73.73 0 0 1-.17.23.85.85 0 0 1-.28.18.97.97 0 0 1-.37.06 1 1 0 0 1-.87-.5 1.06 1.06 0 0 1-.14-.53c0-.2.05-.39.14-.54a1 1 0 0 1 .39-.38c.16-.1.34-.14.55-.14Zm2.07 3.17a.27.27 0 0 1-.2-.08.27.27 0 0 1-.07-.2c0-.08.02-.14.08-.2a.27.27 0 0 1 .2-.08c.07 0 .14.03.2.09.04.05.07.11.07.2 0 .07-.03.13-.08.19a.27.27 0 0 1-.2.08Zm1.11 0a.27.27 0 0 1-.2-.08.27.27 0 0 1-.08-.2c0-.08.03-.14.09-.2a.27.27 0 0 1 .2-.08c.07 0 .13.03.19.09.05.05.08.11.08.2 0 .07-.03.13-.08.19a.27.27 0 0 1-.2.08Zm1.1 0a.27.27 0 0 1-.19-.08.27.27 0 0 1-.08-.2c0-.08.03-.14.08-.2a.27.27 0 0 1 .2-.08c.08 0 .14.03.2.09.05.05.08.11.08.2 0 .07-.03.13-.09.19a.27.27 0 0 1-.2.08Z"
          />
        </g>
        <rect
          width={66.04}
          height={6.23}
          x={8.98}
          y={71.88}
          stroke={templateStyles['border']}
          strokeWidth={0.31}
          rx={0.93}
        />
      </g>
      <path
        fill={templateStyles['icon']}
        fillRule="evenodd"
        d="M30.51 91.12v1.94h.47v-1.94h1.95v-.47h-1.95V88.7h-.47v1.95h-1.94v.47h1.94Z"
        clipRule="evenodd"
      />
      <text
        xmlSpace="preserve"
        fill={templateStyles['fontColor']}
        fontFamily={templateStyles['fontFamily']}
        fontSize={4.36}
        fontWeight={510}
        letterSpacing="0em"
        style={{
          whiteSpace: 'pre'
        }}
      >
        <tspan x={34.74} y={92.05}>
          {formatMessage(messages['templates-preview.add-entry'])}
        </tspan>
      </text>
      <rect
        width={76}
        height={95}
        x={83.01}
        y={4}
        fill={templateStyles['boardBackground']}
        rx={0.93}
      />
      <rect
        width={19.69}
        height={5.92}
        x={85.66}
        y={7.89}
        fill={tagBackgroundColors['greyLight']}
        rx={0.78}
      />
      <rect
        width={19.69}
        height={5.92}
        x={85.66}
        y={7.89}
        stroke={tagBorderColors['greyLight']}
        strokeWidth={0.31}
        rx={0.78}
      />
      <text
        xmlSpace="preserve"
        fill={templateStyles['fontColor']}
        fontFamily={templateStyles['fontFamily']}
        fontSize={4.36}
        letterSpacing="0em"
        style={{
          whiteSpace: 'pre'
        }}
      >
        <tspan x={87.9} y={12.01}>
          {formatMessage(okrTrackerMessages['okr-tracker.field-4-select-option-2'])}
        </tspan>
      </text>
      <g filter="url(#okrTracker-c)">
        <rect
          width={71.02}
          height={58.14}
          x={85.5}
          y={17.7}
          fill={templateStyles['background']}
          rx={1.25}
        />
        <text
          xmlSpace="preserve"
          fill={templateStyles['fontColor']}
          fontFamily={templateStyles['fontFamily']}
          fontSize={4.98}
          fontWeight="bold"
          letterSpacing="0em"
          style={{
            whiteSpace: 'pre'
          }}
        >
          <tspan x={88} y={26.32}>
            {formatMessage(okrTrackerMessages['okr-tracker.entry-2-cell-2']).substring(
              0,
              23
            )}
          </tspan>
          <tspan x={87} y={32.55}>
            {formatMessage(okrTrackerMessages['okr-tracker.entry-2-cell-2']).substring(
              23
            )}
          </tspan>
        </text>
        <text
          xmlSpace="preserve"
          fill={templateStyles['fontColor']}
          fontFamily={templateStyles['fontFamily']}
          fontSize={4.36}
          letterSpacing="0em"
          style={{
            whiteSpace: 'pre'
          }}
        >
          <tspan x={88} y={41.59}>
            {'0%'}
          </tspan>
        </text>
        <rect
          width={38.72}
          height={8.25}
          x={88}
          y={46.42}
          fill={templateStyles['userBackground']}
          rx={4.12}
        />
        <path
          fill={templateStyles['icon']}
          fillRule="evenodd"
          d="M91.73 48.52a2.02 2.02 0 1 0 1.01 3.78l.24.4a2.5 2.5 0 1 1 1.25-2.16c0 .27-.1.56-.26.79a.96.96 0 0 1-.79.41.69.69 0 0 1-.66-.44c-.35.42-.93.6-1.41.32-.55-.32-.65-1.06-.32-1.62.32-.56 1.01-.85 1.57-.54a1.07 1.07 0 0 1 .5 1.01c0 .22.01.44.07.6.03.08.07.13.1.16s.08.05.15.05a.5.5 0 0 0 .41-.23.9.9 0 0 0 .17-.5c0-1.12-.9-2.03-2.03-2.03Zm.67 1.9c0-.25-.1-.45-.28-.55-.27-.16-.7-.04-.93.36-.23.4-.11.83.15.99.27.15.7.04.93-.37a.92.92 0 0 0 .13-.4v-.03Z"
          clipRule="evenodd"
        />
        <path
          fill={templateStyles['fontColor']}
          d="m96.75 52.04-1.13-3.07h.4l.9 2.58h.04l.9-2.58h.4l-1.13 3.07h-.38Zm2.01 0v-2.3h.37v2.3h-.37Zm.19-2.73a.25.25 0 0 1-.18-.08.25.25 0 0 1-.08-.18c0-.07.03-.13.08-.18a.25.25 0 0 1 .18-.07.25.25 0 0 1 .26.26c0 .06-.03.12-.08.17a.25.25 0 0 1-.18.08Zm1.82 2.77c-.22 0-.4-.04-.56-.14a.98.98 0 0 1-.37-.42 1.44 1.44 0 0 1-.13-.63c0-.24.05-.45.13-.63a.97.97 0 0 1 .93-.55c.18 0 .34.03.48.1a.85.85 0 0 1 .48.63v.01h-.37a.53.53 0 0 0-.2-.3.62.62 0 0 0-.4-.11.62.62 0 0 0-.59.4c-.05.12-.08.27-.08.45s.03.33.09.46a.7.7 0 0 0 .23.3c.1.07.22.1.36.1.15 0 .28-.03.38-.1.1-.06.16-.16.2-.29h.01l.37-.01v.02a.98.98 0 0 1-.17.37.82.82 0 0 1-.32.25c-.13.06-.29.1-.47.1Zm2.36-.02c-.24 0-.41-.05-.52-.14-.1-.1-.15-.25-.15-.47v-1.4h-.37v-.3h.37v-.6h.38v.6h.5v.3h-.5v1.3c0 .14.02.24.08.3.05.05.13.08.25.08a1.36 1.36 0 0 0 .17 0v.3a2.62 2.62 0 0 1-.21.03Zm1.68.02c-.22 0-.4-.04-.57-.14a.97.97 0 0 1-.36-.4 1.45 1.45 0 0 1-.13-.64c0-.25.04-.46.13-.64a.96.96 0 0 1 .93-.55c.22 0 .4.05.56.14.16.1.28.23.37.41.08.18.13.39.13.63 0 .25-.05.46-.13.64a.96.96 0 0 1-.37.41c-.16.1-.34.14-.56.14Zm0-.32c.14 0 .27-.04.37-.1.1-.07.17-.17.23-.3.05-.13.08-.28.08-.46 0-.19-.03-.34-.08-.47a.63.63 0 0 0-.23-.3.64.64 0 0 0-.37-.1.64.64 0 0 0-.37.1.63.63 0 0 0-.23.3c-.05.13-.08.28-.08.46 0 .19.03.34.08.47.05.13.13.23.23.3.1.06.22.1.37.1Zm1.63.28v-2.3h.37v.35h.04a.54.54 0 0 1 .22-.28c.1-.07.23-.1.39-.1h.1l.08.01v.36a1.07 1.07 0 0 0-.22-.02.67.67 0 0 0-.32.07.54.54 0 0 0-.21.2.55.55 0 0 0-.08.3v1.41h-.37Zm1.67 0v-2.3h.37v2.3h-.37Zm.19-2.73a.25.25 0 0 1-.26-.26c0-.07.03-.13.08-.18a.25.25 0 0 1 .18-.07c.07 0 .13.02.18.07.05.05.07.11.07.18a.25.25 0 0 1-.26.26Zm1.5 2.77a.9.9 0 0 1-.38-.08.68.68 0 0 1-.28-.24.65.65 0 0 1-.1-.36c0-.14.03-.25.1-.35.07-.1.16-.18.29-.23.12-.06.27-.09.45-.1l.84-.05v.3l-.8.05a.7.7 0 0 0-.38.1.32.32 0 0 0-.12.27c0 .12.05.21.13.28.1.06.2.1.34.1.12 0 .23-.03.33-.08a.6.6 0 0 0 .23-.2.53.53 0 0 0 .09-.3v-.72c0-.14-.05-.25-.13-.32-.09-.08-.22-.11-.39-.11a.68.68 0 0 0-.34.07.36.36 0 0 0-.17.2v.01h-.38a.62.62 0 0 1 .16-.32.8.8 0 0 1 .3-.22c.14-.05.28-.07.44-.07.2 0 .35.03.48.09s.23.15.3.26c.06.12.1.25.1.41v1.57h-.37v-.33h-.04a.79.79 0 0 1-.4.33.92.92 0 0 1-.3.04Zm4.06.04c-.22 0-.42-.04-.58-.11a1 1 0 0 1-.4-.3.87.87 0 0 1-.17-.45v-.02h.38v.02c.02.1.05.2.12.27.07.07.16.13.28.17a1.19 1.19 0 0 0 .77 0c.1-.05.2-.11.25-.2.07-.07.1-.16.1-.27a.42.42 0 0 0-.14-.32.97.97 0 0 0-.46-.2l-.34-.08c-.31-.06-.53-.17-.67-.31a.76.76 0 0 1-.21-.55c0-.17.04-.32.13-.45.1-.13.22-.24.39-.31.16-.07.35-.11.56-.11.2 0 .38.04.54.11.16.07.28.17.38.3.09.12.14.26.15.4v.04h-.38v-.03a.47.47 0 0 0-.12-.24.61.61 0 0 0-.23-.17.89.89 0 0 0-.35-.06.94.94 0 0 0-.35.06c-.1.04-.18.1-.24.17a.42.42 0 0 0-.1.28c0 .12.05.22.14.3.1.1.25.16.45.2l.34.08c.22.05.4.1.52.18.13.08.23.17.29.28.06.1.09.23.09.38 0 .2-.05.36-.14.5a.92.92 0 0 1-.4.32c-.17.08-.37.12-.6.12Zm2.55-.06c-.24 0-.41-.05-.52-.14-.1-.1-.16-.25-.16-.47v-1.4h-.36v-.3h.36v-.6h.39v.6h.5v.3h-.5v1.3c0 .14.02.24.07.3.06.05.14.08.26.08a1.36 1.36 0 0 0 .17 0v.3a2.62 2.62 0 0 1-.21.03Zm.96.79a.88.88 0 0 1-.16-.01v-.3a.4.4 0 0 0 .41-.07.56.56 0 0 0 .16-.29l.04-.13-.85-2.3h.4l.7 2.12-.14-.23h.17l-.14.23.7-2.12h.4l-.9 2.43c-.07.18-.13.31-.2.4a.57.57 0 0 1-.25.2c-.09.05-.2.07-.34.07Zm2.2-.8v-3.21h.36v3.2h-.37Zm2.01.03c-.22 0-.4-.04-.56-.14a.96.96 0 0 1-.36-.4 1.45 1.45 0 0 1-.13-.64c0-.23.04-.44.13-.62a1 1 0 0 1 .35-.42c.16-.1.34-.15.55-.15.2 0 .38.05.53.14.15.1.27.23.35.4.08.18.12.38.12.6V51h-1.84v-.3h1.65l-.18.28v-.15c0-.18-.03-.33-.08-.44a.57.57 0 0 0-.55-.35.61.61 0 0 0-.34.09.62.62 0 0 0-.23.27 1 1 0 0 0-.08.43v.15c0 .16.03.3.08.42a.62.62 0 0 0 .6.35c.1 0 .2-.01.27-.04a.6.6 0 0 0 .19-.1.4.4 0 0 0 .1-.14l.01-.02h.37v.02a.71.71 0 0 1-.1.22.84.84 0 0 1-.2.2 1 1 0 0 1-.29.14c-.1.04-.22.05-.36.05Zm2.34 0c-.17 0-.32-.02-.45-.07a.78.78 0 0 1-.31-.22.62.62 0 0 1-.14-.33h.38c.03.1.09.17.18.23s.2.09.36.09c.1 0 .19-.02.27-.05a.47.47 0 0 0 .19-.12.28.28 0 0 0 .06-.19.25.25 0 0 0-.1-.2.72.72 0 0 0-.3-.14l-.35-.08a1.3 1.3 0 0 1-.36-.13.54.54 0 0 1-.2-.2.59.59 0 0 1-.07-.3c0-.12.04-.24.11-.34.08-.1.18-.18.31-.23a1.11 1.11 0 0 1 .86-.01.63.63 0 0 1 .44.54h-.36a.37.37 0 0 0-.17-.23.6.6 0 0 0-.33-.08c-.1 0-.18.01-.25.04a.4.4 0 0 0-.17.12.28.28 0 0 0-.06.18c0 .06.02.1.04.14.03.04.07.07.13.1s.13.06.22.08l.35.09c.22.05.38.13.48.22.1.1.16.23.16.4 0 .14-.04.26-.12.36a.8.8 0 0 1-.33.25c-.14.05-.3.08-.47.08Z"
        />
        <rect
          width={9.69}
          height={5.92}
          x={88.15}
          y={57.31}
          fill={tagBackgroundColors['yellow']}
          rx={0.78}
        />
        <rect
          width={9.69}
          height={5.92}
          x={88.15}
          y={57.31}
          stroke={tagBorderColors['yellow']}
          strokeWidth={0.31}
          rx={0.78}
        />
        <text
          xmlSpace="preserve"
          fill={templateStyles['fontColor']}
          fontFamily={templateStyles['fontFamily']}
          fontSize={4.36}
          letterSpacing="0em"
          style={{
            whiteSpace: 'pre'
          }}
        >
          <tspan x={90} y={61.44}>
            {formatMessage(okrTrackerMessages['okr-tracker.field-5-select-option-1'])}
          </tspan>
        </text>
        <g clipPath="url(#okrTracker-d)">
          <rect
            width={66.04}
            height={6.23}
            x={88}
            y={65.88}
            fill={templateStyles['background']}
            rx={0.93}
          />
          <path fill={templateStyles['background']} d="M88.93 66.81h4.36v4.36h-4.36z" />
          <path
            fill={templateStyles['link']}
            d="M90.51 68.9c-.04-.05-.11-.05-.14.01l-.7 1.41a.08.08 0 0 0 .07.12h.98a.08.08 0 0 0 .08-.04c.21-.44.08-1.1-.29-1.5Zm.52-1.29c-.4.63-.37 1.32-.1 1.84l.46.95c.02.03.05.04.08.04h.98a.08.08 0 0 0 .08-.12l-1.36-2.7c-.03-.07-.1-.07-.14 0ZM94.62 70.88V67.8h1.86v.35H95v1.06h1.36v.34H95v1.33h-.38Zm3.21.04a.89.89 0 0 1-.43-.1.64.64 0 0 1-.27-.29 1.1 1.1 0 0 1-.09-.46v-1.49h.37v1.4c0 .2.04.36.12.46.08.1.22.15.4.15.1 0 .19-.02.26-.05a.52.52 0 0 0 .2-.12c.05-.06.1-.13.12-.2a.86.86 0 0 0 .04-.28v-1.36h.37v2.3h-.37v-.35h-.04a.64.64 0 0 1-.15.21.65.65 0 0 1-.23.13.93.93 0 0 1-.3.05Zm2.72 0c-.22 0-.41-.05-.57-.15a.96.96 0 0 1-.36-.4 1.45 1.45 0 0 1-.13-.63c0-.24.05-.45.13-.63a1 1 0 0 1 .36-.42c.16-.1.34-.15.54-.15a.92.92 0 0 1 .88.55c.08.17.13.37.13.6v.15h-1.84v-.3h1.65l-.19.27v-.15c0-.18-.02-.33-.08-.44a.57.57 0 0 0-.55-.35.61.61 0 0 0-.33.1.62.62 0 0 0-.23.26 1 1 0 0 0-.09.43v.15c0 .16.03.3.09.42a.62.62 0 0 0 .6.36c.1 0 .19-.02.27-.05a.6.6 0 0 0 .19-.1.4.4 0 0 0 .1-.14v-.02h.38v.02a.71.71 0 0 1-.11.23.84.84 0 0 1-.2.2 1 1 0 0 1-.28.14c-.1.03-.23.05-.36.05Zm1.57-.04v-3.2h.37v3.2h-.37Zm1.1 0v-2.3h.36v2.3h-.37Zm.18-2.74a.25.25 0 0 1-.18-.08.25.25 0 0 1-.08-.18c0-.07.03-.13.08-.18a.25.25 0 0 1 .18-.07.24.24 0 0 1 .25.26.25.25 0 0 1-.25.26Zm.88 2.74v-2.3h.37v.35h.03a.65.65 0 0 1 .26-.29c.1-.06.24-.1.41-.1.26 0 .46.08.6.22.14.15.2.36.2.63v1.49h-.37v-1.4c0-.2-.04-.36-.13-.46-.08-.1-.22-.15-.4-.15a.61.61 0 0 0-.32.08.54.54 0 0 0-.2.22.77.77 0 0 0-.08.35v1.36h-.37Zm3.5.8c-.2 0-.35-.02-.5-.07a.78.78 0 0 1-.32-.22.65.65 0 0 1-.15-.33h.38c.03.09.09.16.19.21.1.06.23.09.4.09.2 0 .36-.05.47-.14.12-.1.18-.23.18-.4v-.46h-.04a.78.78 0 0 1-.72.4.93.93 0 0 1-.51-.14.94.94 0 0 1-.33-.4 1.33 1.33 0 0 1-.12-.57c0-.21.04-.4.12-.57a.9.9 0 0 1 .85-.54c.11 0 .2.02.3.05.1.04.17.08.24.15a.8.8 0 0 1 .18.22h.02v-.38h.37v2.26c0 .17-.04.32-.12.45a.8.8 0 0 1-.36.3c-.15.06-.33.1-.54.1Zm-.03-1.25c.15 0 .27-.03.37-.1.1-.07.18-.16.23-.27a.92.92 0 0 0 .09-.4v-.01a.93.93 0 0 0-.09-.4.64.64 0 0 0-.23-.28.64.64 0 0 0-.37-.1.64.64 0 0 0-.36.1.64.64 0 0 0-.22.28 1 1 0 0 0-.08.4 1 1 0 0 0 .08.4c.05.12.12.21.22.28.1.07.22.1.36.1Zm3.9.49c-.22 0-.41-.05-.57-.15a.96.96 0 0 1-.36-.4 1.45 1.45 0 0 1-.13-.63c0-.24.05-.45.13-.63a1 1 0 0 1 .36-.42c.15-.1.34-.15.54-.15a.93.93 0 0 1 .88.55c.08.17.13.37.13.6v.15h-1.84v-.3h1.64l-.18.27v-.15c0-.18-.03-.33-.08-.44a.57.57 0 0 0-.55-.35.62.62 0 0 0-.33.1.62.62 0 0 0-.23.26 1 1 0 0 0-.09.43v.15c0 .16.03.3.09.42a.62.62 0 0 0 .6.36c.1 0 .19-.02.26-.05a.6.6 0 0 0 .2-.1.4.4 0 0 0 .1-.14v-.02h.38v.02a.71.71 0 0 1-.11.23.84.84 0 0 1-.2.2 1 1 0 0 1-.28.14c-.1.03-.23.05-.36.05Zm1.55-.04v-2.3h.37v.35h.03a.65.65 0 0 1 .26-.29c.1-.06.24-.1.41-.1.26 0 .46.08.6.22.13.15.2.36.2.63v1.49h-.37v-1.4c0-.2-.04-.36-.13-.46-.08-.1-.22-.15-.4-.15a.61.61 0 0 0-.32.08.54.54 0 0 0-.2.22.77.77 0 0 0-.08.35v1.36h-.37Zm3.5.8c-.2 0-.36-.02-.5-.07a.8.8 0 0 1-.32-.22.65.65 0 0 1-.15-.33h.38c.03.09.08.16.19.21.1.06.23.09.4.09.2 0 .36-.05.47-.14.12-.1.18-.23.18-.4v-.46h-.04a.76.76 0 0 1-.42.35.93.93 0 0 1-.3.05.92.92 0 0 1-.51-.14.93.93 0 0 1-.33-.4 1.31 1.31 0 0 1-.12-.57c0-.21.04-.4.12-.57.08-.17.19-.3.33-.4.15-.09.32-.14.52-.14.1 0 .2.02.3.05a.76.76 0 0 1 .42.37h.02v-.38h.37v2.26a.8.8 0 0 1-.12.45.8.8 0 0 1-.36.3c-.15.06-.33.1-.54.1Zm-.03-1.25c.14 0 .27-.03.37-.1.1-.07.18-.16.23-.27a.93.93 0 0 0 .09-.4v-.01a.95.95 0 0 0-.09-.4.64.64 0 0 0-.23-.28.65.65 0 0 0-.37-.1.63.63 0 0 0-.36.1.65.65 0 0 0-.22.28 1 1 0 0 0-.08.4 1 1 0 0 0 .08.4c.05.12.12.21.22.28.1.07.22.1.36.1Zm2.36.49a.9.9 0 0 1-.39-.09.68.68 0 0 1-.27-.23.64.64 0 0 1-.1-.36.6.6 0 0 1 .1-.36c.06-.1.15-.17.28-.23.12-.05.27-.09.45-.1l.84-.05v.3l-.8.05a.7.7 0 0 0-.38.1.31.31 0 0 0-.12.27c0 .12.05.21.14.28.08.06.2.1.33.1s.24-.03.33-.08c.1-.05.18-.12.23-.2a.52.52 0 0 0 .09-.3v-.71c0-.15-.04-.25-.13-.33-.08-.07-.21-.11-.38-.11a.68.68 0 0 0-.34.07.36.36 0 0 0-.18.21h-.37a.62.62 0 0 1 .15-.32.8.8 0 0 1 .31-.21c.13-.05.28-.08.44-.08.18 0 .34.03.47.1.13.05.23.14.3.26.07.11.1.25.1.4v1.58h-.37v-.34h-.03a.77.77 0 0 1-.7.38Zm2.72.77c-.18 0-.34-.03-.48-.08a.8.8 0 0 1-.33-.22.66.66 0 0 1-.15-.33h.39c.02.09.08.16.18.21.1.06.23.09.4.09.2 0 .36-.05.47-.14.12-.1.18-.23.18-.4v-.46h-.04a.76.76 0 0 1-.42.35.93.93 0 0 1-.3.05.92.92 0 0 1-.5-.14.93.93 0 0 1-.34-.4 1.33 1.33 0 0 1-.12-.57c0-.21.04-.4.12-.57.08-.17.2-.3.34-.4.14-.09.31-.14.51-.14.11 0 .21.02.3.05a.76.76 0 0 1 .42.37h.02v-.38h.37v2.26c0 .17-.04.32-.12.45a.8.8 0 0 1-.36.3c-.15.06-.33.1-.54.1Zm-.01-1.26c.14 0 .26-.03.36-.1.1-.07.18-.16.23-.27a.93.93 0 0 0 .09-.4v-.01a.95.95 0 0 0-.09-.4.64.64 0 0 0-.23-.28.64.64 0 0 0-.36-.1.63.63 0 0 0-.37.1.65.65 0 0 0-.22.28 1 1 0 0 0-.08.4 1 1 0 0 0 .08.4c.05.12.13.21.22.28.1.07.22.1.37.1Zm2.66.49c-.22 0-.4-.05-.56-.15a.96.96 0 0 1-.37-.4 1.45 1.45 0 0 1-.12-.63c0-.24.04-.45.13-.63a1 1 0 0 1 .35-.42c.16-.1.34-.15.55-.15a.93.93 0 0 1 .88.55c.08.17.12.37.12.6v.15h-1.84v-.3h1.65l-.18.27v-.15c0-.18-.03-.33-.08-.44a.57.57 0 0 0-.56-.35.62.62 0 0 0-.33.1.62.62 0 0 0-.23.26 1 1 0 0 0-.08.43v.15c0 .16.03.3.08.42a.62.62 0 0 0 .6.36c.1 0 .2-.02.27-.05a.6.6 0 0 0 .19-.1.4.4 0 0 0 .1-.14l.01-.02h.37v.02a.7.7 0 0 1-.1.23.87.87 0 0 1-.48.34c-.11.03-.23.05-.37.05Zm1.55-.04v-2.3h.38v.35h.03a.61.61 0 0 1 .23-.29.7.7 0 0 1 .39-.1c.1 0 .2.02.28.05.08.04.15.08.21.15.06.05.1.12.14.2h.04a.75.75 0 0 1 .4-.35c.1-.03.2-.05.3-.05.16 0 .29.03.4.09.1.06.19.14.24.25.06.11.09.25.09.41v1.59h-.37v-1.5c0-.12-.02-.21-.05-.29a.34.34 0 0 0-.16-.16.56.56 0 0 0-.27-.06c-.1 0-.2.02-.28.07a.5.5 0 0 0-.18.2.54.54 0 0 0-.07.26v1.48h-.37v-1.56c0-.1-.02-.17-.06-.24a.38.38 0 0 0-.17-.16.54.54 0 0 0-.25-.05c-.1 0-.19.03-.27.08a.56.56 0 0 0-.19.21.64.64 0 0 0-.06.3v1.42h-.38Zm4.73.04c-.21 0-.4-.05-.56-.15a.95.95 0 0 1-.36-.4 1.45 1.45 0 0 1-.13-.63c0-.24.05-.45.13-.63a1 1 0 0 1 .36-.42c.15-.1.33-.15.54-.15a.93.93 0 0 1 .88.55c.08.17.12.37.12.6v.15h-1.84v-.3h1.65l-.18.27v-.15c0-.18-.03-.33-.08-.44a.57.57 0 0 0-.22-.26.61.61 0 0 0-.33-.09.62.62 0 0 0-.33.1.62.62 0 0 0-.23.26 1 1 0 0 0-.09.43v.15c0 .16.03.3.09.42a.62.62 0 0 0 .6.36c.1 0 .19-.02.26-.05a.6.6 0 0 0 .2-.1.4.4 0 0 0 .1-.14v-.02h.38v.02a.7.7 0 0 1-.11.23.87.87 0 0 1-.48.34c-.1.03-.23.05-.37.05Zm1.56-.04v-2.3h.37v.35h.03a.65.65 0 0 1 .25-.29c.11-.06.25-.1.42-.1.26 0 .46.08.6.22.13.15.2.36.2.63v1.49h-.37v-1.4c0-.2-.04-.36-.13-.46-.09-.1-.22-.15-.4-.15a.61.61 0 0 0-.32.08.54.54 0 0 0-.2.22.77.77 0 0 0-.08.35v1.36h-.37Zm3.36.01c-.24 0-.4-.04-.51-.14-.1-.1-.16-.25-.16-.47v-1.4h-.36v-.3h.36v-.6h.38v.6h.5v.3h-.5v1.3c0 .14.03.24.08.3s.14.09.26.09a1.4 1.4 0 0 0 .16-.01v.31a2.62 2.62 0 0 1-.21.02Zm1.07 0a.27.27 0 0 1-.2-.07.27.27 0 0 1-.08-.2c0-.08.03-.14.09-.2a.27.27 0 0 1 .2-.08c.07 0 .13.03.19.09.05.05.08.11.08.2 0 .07-.03.13-.08.19a.26.26 0 0 1-.2.08Zm0-1.64a.27.27 0 0 1-.2-.08.27.27 0 0 1-.08-.2c0-.07.03-.14.09-.2a.27.27 0 0 1 .2-.07c.07 0 .13.02.19.08.05.05.08.12.08.2 0 .07-.03.13-.08.19a.26.26 0 0 1-.2.08Zm3.03 1.64c-.23 0-.4-.04-.5-.14-.11-.1-.17-.25-.17-.47v-1.4h-.36v-.3h.36v-.6h.39v.6h.5v.3h-.5v1.3c0 .14.02.24.07.3s.14.09.26.09a1.4 1.4 0 0 0 .17-.01v.31a2.57 2.57 0 0 1-.22.02Zm.8-.01v-3.2h.36v1.25h.04a.65.65 0 0 1 .25-.29c.1-.06.25-.1.42-.1.17 0 .31.03.43.1s.21.16.28.29c.06.13.09.28.09.46v1.49H142v-1.4c0-.2-.04-.36-.13-.46-.09-.1-.22-.15-.4-.15a.62.62 0 0 0-.32.08.54.54 0 0 0-.21.22.76.76 0 0 0-.08.35v1.36h-.37Zm3.48.04c-.22 0-.41-.05-.57-.15a.96.96 0 0 1-.36-.4 1.46 1.46 0 0 1-.13-.63c0-.24.05-.45.13-.63a1 1 0 0 1 .36-.42c.16-.1.34-.15.54-.15a.92.92 0 0 1 .88.55c.08.17.13.37.13.6v.15h-1.84v-.3h1.65l-.19.27v-.15c0-.18-.02-.33-.08-.44a.57.57 0 0 0-.55-.35.61.61 0 0 0-.33.1.62.62 0 0 0-.23.26 1 1 0 0 0-.09.43v.15c0 .16.03.3.09.42a.62.62 0 0 0 .6.36c.1 0 .19-.02.26-.05a.6.6 0 0 0 .2-.1.4.4 0 0 0 .1-.14v-.02h.38v.02a.71.71 0 0 1-.11.23.85.85 0 0 1-.2.2.98.98 0 0 1-.28.14c-.1.03-.23.05-.36.05Zm2.78.72v-3.06h.37v.37h.03a.76.76 0 0 1 .42-.36c.1-.03.19-.05.3-.05.2 0 .36.05.5.15.15.1.26.24.34.41.08.18.12.39.12.63s-.04.45-.12.63a.88.88 0 0 1-.84.56.86.86 0 0 1-.55-.19.68.68 0 0 1-.17-.22h-.03v1.13h-.37Zm1.03-1.05c.14 0 .26-.03.36-.1.1-.07.18-.17.23-.3.05-.13.08-.28.08-.46s-.03-.34-.08-.46a.64.64 0 0 0-.23-.3.61.61 0 0 0-.36-.1.62.62 0 0 0-.36.1.66.66 0 0 0-.23.3c-.05.13-.08.28-.08.46s.03.33.08.46.13.23.23.3c.1.06.22.1.36.1Zm1.93.3a.27.27 0 0 1-.2-.07.27.27 0 0 1-.08-.2c0-.08.03-.14.08-.2a.27.27 0 0 1 .2-.08c.08 0 .14.03.2.09.05.05.08.11.08.2 0 .07-.03.13-.09.19a.27.27 0 0 1-.19.08Zm1.1 0a.27.27 0 0 1-.19-.07.27.27 0 0 1-.08-.2c0-.08.03-.14.08-.2a.27.27 0 0 1 .2-.08c.07 0 .14.03.2.09.05.05.07.11.07.2 0 .07-.02.13-.08.19a.27.27 0 0 1-.2.08Zm1.11 0a.27.27 0 0 1-.2-.07.27.27 0 0 1-.07-.2c0-.08.02-.14.08-.2a.27.27 0 0 1 .2-.08c.07 0 .13.03.19.09.05.05.08.11.08.2 0 .07-.03.13-.08.19a.27.27 0 0 1-.2.08Z"
          />
        </g>
        <rect
          width={66.04}
          height={6.23}
          x={88}
          y={65.88}
          stroke={templateStyles['border']}
          strokeWidth={0.31}
          rx={0.93}
        />
      </g>
      <path
        fill={templateStyles['icon']}
        fillRule="evenodd"
        d="M109.53 86.1v1.95h.46V86.1h1.95v-.47h-1.95V83.7h-.46v1.94h-1.95v.47h1.95Z"
        clipRule="evenodd"
      />
      <text
        xmlSpace="preserve"
        fill={templateStyles['fontColor']}
        fontFamily={templateStyles['fontFamily']}
        fontSize={4.36}
        fontWeight={510}
        letterSpacing="0em"
        style={{
          whiteSpace: 'pre'
        }}
      >
        <tspan x={113.76} y={87.03}>
          {formatMessage(messages['templates-preview.add-entry'])}
        </tspan>
      </text>
      <rect
        width={76}
        height={95}
        x={162.03}
        y={4}
        fill={templateStyles['boardBackground']}
        rx={0.93}
      />
      <rect
        width={22.69}
        height={5.92}
        x={164.67}
        y={7.89}
        fill={tagBackgroundColors['blueLight']}
        rx={0.78}
      />
      <rect
        width={22.69}
        height={5.92}
        x={164.67}
        y={7.89}
        stroke={tagBorderColors['blueLight']}
        strokeWidth={0.31}
        rx={0.78}
      />
      <text
        xmlSpace="preserve"
        fill={templateStyles['fontColor']}
        fontFamily={templateStyles['fontFamily']}
        fontSize={4.36}
        letterSpacing="0em"
        style={{
          whiteSpace: 'pre'
        }}
      >
        <tspan x={166.6} y={12.01}>
          {formatMessage(okrTrackerMessages['okr-tracker.field-4-select-option-3'])}
        </tspan>
      </text>
      <g filter="url(#okrTracker-e)">
        <rect
          width={71.02}
          height={58.14}
          x={164.52}
          y={17.7}
          fill={templateStyles['background']}
          rx={1.25}
        />
        <text
          xmlSpace="preserve"
          fill={templateStyles['fontColor']}
          fontFamily={templateStyles['fontFamily']}
          fontSize={4.98}
          fontWeight="bold"
          letterSpacing="0em"
          style={{
            whiteSpace: 'pre'
          }}
        >
          <tspan x={167.01} y={26.32}>
            {formatMessage(okrTrackerMessages['okr-tracker.entry-3-cell-2']).substring(
              0,
              25
            )}
          </tspan>
          <tspan x={166.01} y={32.55}>
            {formatMessage(okrTrackerMessages['okr-tracker.entry-3-cell-2']).substring(
              25
            )}
          </tspan>
        </text>
        <text
          xmlSpace="preserve"
          fill={templateStyles['fontColor']}
          fontFamily={templateStyles['fontFamily']}
          fontSize={4.36}
          letterSpacing="0em"
          style={{
            whiteSpace: 'pre'
          }}
        >
          <tspan x={167.01} y={41.59}>
            {'80%'}
          </tspan>
        </text>
        <rect
          width={33.72}
          height={8.25}
          x={167.01}
          y={46.42}
          fill={templateStyles['userBackground']}
          rx={4.12}
        />
        <path
          fill={templateStyles['icon']}
          fillRule="evenodd"
          d="M170.75 48.52a2.02 2.02 0 1 0 1 3.78l.24.4a2.48 2.48 0 0 1-3.73-2.16 2.5 2.5 0 1 1 4.98 0c0 .27-.09.56-.26.79a.96.96 0 0 1-.78.41.69.69 0 0 1-.66-.44c-.36.42-.94.6-1.42.32-.55-.32-.64-1.06-.32-1.62.33-.56 1.02-.85 1.57-.54.35.2.52.59.5.97v.04c0 .22.02.44.08.6.03.08.06.13.1.16.02.03.07.05.15.05a.5.5 0 0 0 .4-.23.9.9 0 0 0 .17-.5c0-1.12-.9-2.03-2.02-2.03Zm.66 1.9c0-.25-.1-.45-.27-.55-.27-.16-.7-.04-.93.36-.24.4-.12.83.15.99.26.15.7.04.93-.37a.92.92 0 0 0 .12-.4v-.03Z"
          clipRule="evenodd"
        />
        <path
          fill={templateStyles['fontColor']}
          d="M174.87 52.04v-3.02h1.83v.34h-1.45v1.04h1.33v.34h-1.34v1.3h-.37Zm2.41 0V49.8h.37v2.25h-.37Zm.19-2.69a.25.25 0 0 1-.18-.07.25.25 0 0 1-.07-.18.25.25 0 0 1 .25-.25c.07 0 .13.03.17.07a.25.25 0 0 1 0 .36.24.24 0 0 1-.17.07Zm1.7 2.73a.87.87 0 0 1-.83-.55 1.5 1.5 0 0 1-.12-.61c0-.24.04-.45.12-.62a.94.94 0 0 1 .32-.4c.15-.1.31-.15.5-.15a.84.84 0 0 1 .54.19c.07.05.13.12.17.2h.03V48.9h.37v3.15h-.37v-.36h-.03a.77.77 0 0 1-.7.4Zm.08-.32a.6.6 0 0 0 .35-.1c.1-.07.18-.17.23-.3.05-.12.08-.27.08-.44 0-.18-.03-.33-.08-.46a.65.65 0 0 0-.23-.29.6.6 0 0 0-.35-.1.6.6 0 0 0-.35.1.65.65 0 0 0-.23.3 1.2 1.2 0 0 0-.08.44c0 .18.03.33.08.46s.13.22.23.3c.1.06.21.1.35.1Zm2.63.32a.94.94 0 0 1-.91-.54 1.42 1.42 0 0 1-.12-.62c0-.23.04-.43.13-.61.08-.18.2-.31.35-.41.15-.1.33-.15.53-.15s.38.05.53.14c.15.1.26.23.34.4.08.17.12.36.12.59v.14h-1.81v-.29h1.62l-.18.27v-.15c0-.18-.03-.32-.08-.44a.56.56 0 0 0-.54-.34.6.6 0 0 0-.33.1.6.6 0 0 0-.22.25.99.99 0 0 0-.09.43V51c0 .16.03.3.09.4.05.12.13.2.23.27.1.06.22.09.35.09.1 0 .2-.01.27-.04a.59.59 0 0 0 .19-.1.38.38 0 0 0 .1-.14v-.02h.37v.02a.7.7 0 0 1-.1.22.84.84 0 0 1-.48.33c-.1.04-.22.05-.36.05Zm1.55-.04V48.9h.37v3.15h-.37Zm1.07 0V49.8h.37v2.25h-.37Zm.19-2.69a.25.25 0 0 1-.18-.07.25.25 0 0 1-.07-.18.25.25 0 0 1 .25-.25c.07 0 .13.03.18.07.04.05.07.11.07.18a.25.25 0 0 1-.25.25Zm1.64 2.73c-.17 0-.32-.02-.45-.07a.78.78 0 0 1-.3-.22.6.6 0 0 1-.14-.32h.37c.03.1.1.17.18.22.09.06.2.09.35.09.1 0 .2-.01.27-.04a.46.46 0 0 0 .18-.13.27.27 0 0 0 .07-.18.25.25 0 0 0-.1-.2.7.7 0 0 0-.3-.13l-.34-.08a1.28 1.28 0 0 1-.35-.13.55.55 0 0 1-.2-.2.58.58 0 0 1-.07-.28c0-.13.04-.24.11-.34.08-.1.18-.18.3-.24.13-.05.27-.08.43-.08.16 0 .3.02.42.07a.7.7 0 0 1 .3.21c.07.1.12.2.13.32h-.35a.37.37 0 0 0-.17-.21.6.6 0 0 0-.33-.09.61.61 0 0 0-.24.05.39.39 0 0 0-.16.11.27.27 0 0 0-.06.18c0 .05 0 .1.04.14.02.04.06.07.12.1a1 1 0 0 0 .22.08l.34.08c.21.05.37.13.47.22.1.1.16.23.16.39 0 .14-.04.26-.12.36a.78.78 0 0 1-.32.24c-.14.05-.3.08-.46.08Zm2.72-.04v-3.02h1.87v.34h-1.5v.97h1.42v.34h-1.42v1.03h1.5v.34h-1.87Zm2.18.78h-.06v-.32h.05c.13 0 .21-.03.26-.08.05-.05.08-.14.08-.26V49.8h.36v2.36c0 .24-.05.4-.17.5-.1.11-.28.17-.52.17Zm.51-3.47a.25.25 0 0 1-.18-.07.25.25 0 0 1-.07-.18.25.25 0 0 1 .25-.25c.07 0 .13.03.18.07.05.05.07.11.07.18 0 .07-.02.13-.07.18a.24.24 0 0 1-.18.07Zm.88 2.7v-2.26h.36v2.25h-.36Zm.18-2.7a.25.25 0 0 1-.25-.25c0-.07.03-.13.08-.18a.25.25 0 0 1 .17-.07c.07 0 .13.03.18.07a.25.25 0 0 1 0 .36.24.24 0 0 1-.18.07Zm.87 2.7v-2.26h.36v.34h.04a.6.6 0 0 1 .23-.28c.1-.07.23-.1.38-.1a.63.63 0 0 1 .48.19c.06.06.1.13.14.2h.03c.04-.08.1-.14.17-.2.06-.06.14-.1.23-.14.1-.03.19-.05.3-.05.15 0 .28.03.38.08.11.06.2.15.25.26.05.1.08.24.08.4v1.55h-.36v-1.47c0-.11-.02-.2-.06-.28a.34.34 0 0 0-.15-.16.55.55 0 0 0-.26-.06c-.1 0-.2.02-.28.07a.5.5 0 0 0-.18.2.53.53 0 0 0-.06.25v1.45h-.37v-1.53a.45.45 0 0 0-.06-.23.38.38 0 0 0-.16-.15.53.53 0 0 0-.25-.06c-.1 0-.18.03-.26.08a.55.55 0 0 0-.19.2.63.63 0 0 0-.07.3v1.4h-.36Zm4.35.03a.89.89 0 0 1-.39-.08.66.66 0 0 1-.27-.23.64.64 0 0 1-.1-.36.6.6 0 0 1 .1-.34c.06-.1.16-.17.28-.23.12-.05.27-.09.45-.1l.82-.05v.3l-.78.05a.68.68 0 0 0-.38.1.31.31 0 0 0-.11.26c0 .12.04.2.13.27.08.07.2.1.32.1.13 0 .24-.03.33-.08.1-.05.18-.11.23-.2a.51.51 0 0 0 .08-.29v-.7c0-.14-.04-.25-.13-.32-.08-.07-.2-.1-.37-.1a.67.67 0 0 0-.34.06.35.35 0 0 0-.17.2v.01h-.37a.61.61 0 0 1 .15-.32.78.78 0 0 1 .31-.2c.13-.06.27-.08.43-.08.18 0 .34.03.47.09.12.06.22.15.29.26.06.11.1.24.1.4v1.54h-.37v-.33h-.03a.76.76 0 0 1-.4.33.9.9 0 0 1-.28.04Z"
        />
        <rect
          width={9.69}
          height={5.92}
          x={167.16}
          y={57.31}
          fill={tagBackgroundColors['red']}
          rx={0.78}
        />
        <rect
          width={9.69}
          height={5.92}
          x={167.16}
          y={57.31}
          stroke={tagBorderColors['red']}
          strokeWidth={0.31}
          rx={0.78}
        />
        <text
          xmlSpace="preserve"
          fill={templateStyles['fontColor']}
          fontFamily={templateStyles['fontFamily']}
          fontSize={4.36}
          letterSpacing="0em"
          style={{
            whiteSpace: 'pre'
          }}
        >
          <tspan x={169.32} y={61.44}>
            {formatMessage(okrTrackerMessages['okr-tracker.field-5-select-option-2'])}
          </tspan>
        </text>
        <g clipPath="url(#okrTracker-f)">
          <rect
            width={66.04}
            height={6.23}
            x={167.01}
            y={65.88}
            fill={templateStyles['background']}
            rx={0.93}
          />
          <path fill={templateStyles['background']} d="M167.94 66.81h4.36v4.36h-4.36z" />
          <path
            fill={templateStyles['link']}
            d="M169.53 68.9c-.05-.05-.12-.05-.14.01l-.71 1.41v.08l.03.03.04.01h1.03l.03-.04c.22-.44.09-1.1-.28-1.5Zm.51-1.29c-.4.63-.37 1.32-.1 1.84l.47.95c.01.03.04.04.07.04h1.03l.03-.03a.08.08 0 0 0 0-.09l-1.35-2.7c-.03-.07-.1-.07-.15 0ZM173.63 70.88V67.8h.38v1.33h1.69V67.8h.38v3.08h-.38v-1.4H174v1.4h-.38Zm4.13.04c-.22 0-.4-.05-.56-.15a.97.97 0 0 1-.37-.4 1.45 1.45 0 0 1-.13-.64c0-.25.05-.46.13-.64a.96.96 0 0 1 .93-.55c.22 0 .4.05.57.14.15.1.27.24.36.41.09.18.13.4.13.64 0 .25-.04.46-.13.63a.95.95 0 0 1-.93.56Zm0-.33c.15 0 .27-.03.37-.1.1-.07.18-.17.23-.3.05-.12.08-.28.08-.46s-.03-.34-.08-.47a.62.62 0 0 0-.23-.29.64.64 0 0 0-.37-.1.64.64 0 0 0-.37.1.64.64 0 0 0-.23.3c-.05.12-.08.28-.08.46s.03.34.08.46c.06.13.13.23.23.3.1.07.23.1.37.1Zm2 .29-.65-2.3h.37l.45 1.84h.03l.52-1.84h.35l.51 1.84h.04l.45-1.84h.37l-.65 2.3h-.37l-.51-1.78h-.04l-.5 1.78h-.38Zm5 .04a.88.88 0 0 1-.84-.56 1.52 1.52 0 0 1-.12-.63c0-.24.04-.45.12-.63.08-.18.19-.31.33-.41.15-.1.31-.15.5-.15.11 0 .21.02.3.05.1.04.18.08.25.14.08.06.13.13.17.21h.04v-1.27h.37v3.2h-.37v-.36h-.04a.79.79 0 0 1-.17.22.79.79 0 0 1-.25.14.86.86 0 0 1-.3.05Zm.08-.33a.61.61 0 0 0 .6-.4c.05-.13.08-.28.08-.46s-.03-.33-.08-.46a.61.61 0 0 0-.6-.4.62.62 0 0 0-.36.1.66.66 0 0 0-.23.3c-.05.13-.07.28-.07.46s.02.33.07.46c.06.13.13.23.23.3.1.07.23.1.36.1Zm1.76.29v-2.3h.37v2.3h-.37Zm.19-2.74a.25.25 0 0 1-.26-.26c0-.07.03-.13.07-.18a.25.25 0 0 1 .19-.07c.07 0 .13.02.18.07.05.05.07.11.07.18a.25.25 0 0 1-.26.26Zm1.66 2.78c-.17 0-.32-.03-.45-.08a.78.78 0 0 1-.31-.22.62.62 0 0 1-.14-.33h.38c.03.1.09.17.18.23.1.06.21.09.36.09.1 0 .2-.02.27-.05a.47.47 0 0 0 .19-.12.28.28 0 0 0 .06-.19.25.25 0 0 0-.09-.2.72.72 0 0 0-.3-.13l-.36-.09a1.3 1.3 0 0 1-.35-.13.54.54 0 0 1-.2-.2.59.59 0 0 1-.07-.29c0-.13.03-.24.1-.34.08-.1.18-.18.31-.24s.28-.09.44-.09c.16 0 .3.03.43.08.12.05.22.12.3.21.07.1.12.2.14.33h-.37a.37.37 0 0 0-.16-.22.6.6 0 0 0-.34-.09c-.1 0-.18.02-.25.04a.4.4 0 0 0-.16.12.28.28 0 0 0-.07.18c0 .06.02.1.04.14.03.04.07.08.13.1.06.04.13.06.22.09l.35.08c.22.05.38.13.48.23.11.1.16.23.16.4 0 .13-.04.25-.12.36a.8.8 0 0 1-.33.24c-.13.06-.3.09-.47.09Zm2.3-.03c-.24 0-.41-.04-.52-.14-.1-.1-.16-.25-.16-.47v-1.4h-.36v-.3h.36v-.6h.39v.6h.5v.3h-.5v1.3c0 .14.02.24.07.3s.14.09.26.09a1.38 1.38 0 0 0 .17-.01v.31a2.57 2.57 0 0 1-.22.02Zm.76-.01v-2.3h.37v.34h.03a.54.54 0 0 1 .23-.28c.1-.07.23-.1.39-.1h.1l.08.02v.36a1.14 1.14 0 0 0-.22-.03.67.67 0 0 0-.32.08.54.54 0 0 0-.21.2.55.55 0 0 0-.08.28v1.43h-.37Zm1.67 0v-2.3h.37v2.3h-.37Zm.19-2.74a.25.25 0 0 1-.26-.26c0-.07.03-.13.08-.18a.25.25 0 0 1 .18-.07c.07 0 .13.02.18.07.05.05.07.11.07.18a.25.25 0 0 1-.26.26Zm2.02 2.78c-.1 0-.2-.02-.3-.05a.8.8 0 0 1-.24-.14.79.79 0 0 1-.18-.22h-.03v.37h-.37v-3.2h.37v1.26h.03a.7.7 0 0 1 .17-.2c.08-.07.16-.11.25-.15.1-.03.2-.05.3-.05.2 0 .36.05.5.15.15.1.26.23.34.41.08.18.12.39.12.63s-.04.45-.12.63a.95.95 0 0 1-.33.41.88.88 0 0 1-.51.15Zm-.09-.33c.14 0 .26-.03.36-.1.1-.07.18-.17.23-.3.06-.13.08-.28.08-.46s-.02-.34-.08-.46a.65.65 0 0 0-.23-.3.61.61 0 0 0-.36-.1.62.62 0 0 0-.36.1.67.67 0 0 0-.23.3 1.2 1.2 0 0 0-.08.46c0 .18.03.33.08.46.06.13.13.23.23.3.1.06.22.1.36.1Zm2.4.33a.9.9 0 0 1-.44-.1.64.64 0 0 1-.27-.29 1.11 1.11 0 0 1-.09-.46v-1.49h.38v1.4c0 .2.03.36.12.46.07.1.2.15.4.15.1 0 .18-.02.26-.05a.52.52 0 0 0 .31-.33.86.86 0 0 0 .04-.27v-1.36h.37v2.3h-.37v-.35h-.03a.63.63 0 0 1-.16.21.66.66 0 0 1-.22.13.93.93 0 0 1-.3.05Zm2.59-.03c-.24 0-.4-.04-.52-.14-.1-.1-.15-.25-.15-.47v-1.4h-.37v-.3h.37v-.6h.38v.6h.5v.3h-.5v1.3c0 .14.03.24.08.3s.13.09.25.09a1.36 1.36 0 0 0 .17-.01v.31a2.62 2.62 0 0 1-.21.02Zm1.67.03c-.22 0-.4-.05-.56-.15a.96.96 0 0 1-.36-.4 1.45 1.45 0 0 1-.13-.63c0-.24.04-.45.13-.63a.97.97 0 0 1 .9-.57.93.93 0 0 1 .88.55c.08.17.12.37.12.6v.15h-1.84v-.3h1.65l-.18.27v-.15c0-.18-.03-.33-.08-.44a.57.57 0 0 0-.55-.35.62.62 0 0 0-.34.1.62.62 0 0 0-.22.26 1 1 0 0 0-.09.43v.15c0 .16.03.3.08.42.06.11.14.2.24.27.1.06.22.09.36.09.1 0 .2-.02.27-.05a.6.6 0 0 0 .2-.1.38.38 0 0 0 .1-.14v-.02h.37v.02a.7.7 0 0 1-.1.23.87.87 0 0 1-.48.34c-.11.03-.23.05-.37.05Zm2.4 0a.88.88 0 0 1-.84-.56 1.54 1.54 0 0 1-.12-.63c0-.24.04-.45.12-.63.08-.18.2-.31.33-.41.15-.1.32-.15.51-.15a.85.85 0 0 1 .55.2c.07.05.13.12.17.2h.03v-1.27h.37v3.2h-.37v-.36h-.03a.78.78 0 0 1-.18.22.79.79 0 0 1-.24.14.87.87 0 0 1-.3.05Zm.09-.33c.14 0 .26-.04.36-.1.1-.07.18-.17.23-.3.06-.13.08-.28.08-.46s-.03-.33-.08-.46a.66.66 0 0 0-.23-.3.62.62 0 0 0-.36-.1.62.62 0 0 0-.36.1.66.66 0 0 0-.23.3c-.05.13-.08.28-.08.46s.03.33.08.46.13.23.23.3c.1.07.22.1.36.1Zm3.91.33a.97.97 0 0 1-.92-.56 1.43 1.43 0 0 1-.13-.64c0-.24.04-.45.12-.62.09-.18.21-.32.37-.41.16-.1.34-.15.56-.15.18 0 .34.03.48.1a.86.86 0 0 1 .48.63v.01h-.37a.53.53 0 0 0-.2-.3.63.63 0 0 0-.4-.11.61.61 0 0 0-.58.4c-.06.13-.09.28-.09.45 0 .18.03.33.09.46a.6.6 0 0 0 .59.4c.15 0 .28-.02.38-.1.1-.06.16-.15.2-.28l.01-.02h.37v.03a.97.97 0 0 1-.17.36.8.8 0 0 1-.32.26c-.13.06-.29.09-.47.09Zm2.44 0c-.21 0-.4-.05-.56-.15a.97.97 0 0 1-.37-.4 1.45 1.45 0 0 1-.13-.64c0-.25.05-.46.13-.64a.96.96 0 0 1 .93-.55c.22 0 .41.05.57.14.16.1.28.24.36.41.09.18.13.4.13.64 0 .25-.04.46-.13.63a.95.95 0 0 1-.93.56Zm0-.33c.15 0 .27-.03.37-.1.1-.07.18-.17.23-.3.06-.12.08-.28.08-.46s-.02-.34-.08-.47a.62.62 0 0 0-.23-.29.64.64 0 0 0-.37-.1.64.64 0 0 0-.37.1.63.63 0 0 0-.23.3c-.05.12-.08.28-.08.46s.03.34.08.46c.06.13.13.23.24.3.1.07.22.1.36.1Zm2.48.33a.88.88 0 0 1-.84-.56 1.54 1.54 0 0 1-.12-.63c0-.24.04-.45.12-.63.08-.18.2-.31.34-.41.14-.1.3-.15.5-.15a.85.85 0 0 1 .55.2c.07.05.13.12.17.2h.03v-1.27h.37v3.2h-.37v-.36H214a.79.79 0 0 1-.18.22.79.79 0 0 1-.24.14.87.87 0 0 1-.3.05Zm.09-.33c.14 0 .26-.04.36-.1.1-.07.18-.17.23-.3.05-.13.08-.28.08-.46s-.03-.33-.08-.46a.66.66 0 0 0-.23-.3.62.62 0 0 0-.36-.1.61.61 0 0 0-.36.1.65.65 0 0 0-.23.3 1.2 1.2 0 0 0-.08.46c0 .18.03.33.08.46s.13.23.23.3c.1.07.22.1.36.1Zm2.68.33c-.22 0-.4-.05-.56-.15a.96.96 0 0 1-.37-.4 1.45 1.45 0 0 1-.12-.63c0-.24.04-.45.13-.63a1 1 0 0 1 .35-.42c.16-.1.34-.15.55-.15a.93.93 0 0 1 .88.55c.08.17.12.37.12.6v.15h-1.84v-.3h1.65l-.18.27v-.15c0-.18-.03-.33-.08-.44a.57.57 0 0 0-.56-.35.62.62 0 0 0-.33.1.62.62 0 0 0-.23.26 1 1 0 0 0-.08.43v.15c0 .16.03.3.08.42a.62.62 0 0 0 .6.36c.1 0 .2-.02.27-.05a.6.6 0 0 0 .19-.1.4.4 0 0 0 .1-.14l.01-.02h.37v.02a.7.7 0 0 1-.1.23.84.84 0 0 1-.2.2 1 1 0 0 1-.28.14c-.11.03-.23.05-.37.05Zm2.78-.04v-2.3h.37v.34h.04a.54.54 0 0 1 .22-.28c.1-.07.23-.1.39-.1h.1l.08.02v.36a1.12 1.12 0 0 0-.22-.03.67.67 0 0 0-.32.08.54.54 0 0 0-.21.2.55.55 0 0 0-.08.28v1.43h-.37Zm2.53.04c-.22 0-.4-.05-.56-.15a.96.96 0 0 1-.36-.4 1.45 1.45 0 0 1-.13-.63c0-.24.04-.45.13-.63a.97.97 0 0 1 .9-.57.93.93 0 0 1 .88.55c.08.17.12.37.12.6v.15h-1.84v-.3h1.65l-.18.27v-.15c0-.18-.03-.33-.08-.44a.57.57 0 0 0-.55-.35.62.62 0 0 0-.33.1.62.62 0 0 0-.23.26 1 1 0 0 0-.09.43v.15c0 .16.03.3.08.42.06.11.14.2.24.27.1.06.22.09.36.09.1 0 .2-.02.27-.05a.6.6 0 0 0 .2-.1.38.38 0 0 0 .1-.14v-.02h.38v.02a.7.7 0 0 1-.11.23.87.87 0 0 1-.48.34c-.11.03-.23.05-.37.05Zm2.16-.04-.84-2.3h.39l.63 1.9h.03l.63-1.9h.39l-.85 2.3h-.38Zm1.73 0v-2.3h.37v2.3h-.37Zm.18-2.74a.25.25 0 0 1-.18-.08.25.25 0 0 1-.07-.18c0-.07.02-.13.07-.18a.25.25 0 0 1 .18-.07c.07 0 .13.02.19.07.04.05.07.11.07.18 0 .07-.03.13-.07.18a.25.25 0 0 1-.19.08Zm1.82 2.78c-.22 0-.4-.05-.56-.15a.96.96 0 0 1-.36-.4 1.45 1.45 0 0 1-.13-.63c0-.24.04-.45.13-.63a.97.97 0 0 1 .9-.57.93.93 0 0 1 .88.55c.08.17.12.37.12.6v.15h-1.84v-.3h1.65l-.18.27v-.15c0-.18-.03-.33-.08-.44a.57.57 0 0 0-.55-.35.62.62 0 0 0-.34.1.62.62 0 0 0-.23.26 1 1 0 0 0-.08.43v.15c0 .16.03.3.08.42.06.11.14.2.24.27.1.06.22.09.36.09.1 0 .2-.02.27-.05a.6.6 0 0 0 .19-.1.38.38 0 0 0 .1-.14l.01-.02h.37v.02a.7.7 0 0 1-.1.23.87.87 0 0 1-.48.34c-.11.03-.23.05-.37.05Zm1.86-.02a.27.27 0 0 1-.2-.08.27.27 0 0 1-.08-.2c0-.08.03-.14.08-.2a.27.27 0 0 1 .2-.08c.07 0 .14.03.2.09.05.05.07.11.07.2 0 .07-.02.13-.08.19a.27.27 0 0 1-.2.08Zm1.1 0a.27.27 0 0 1-.2-.08.27.27 0 0 1-.07-.2c0-.08.03-.14.08-.2a.27.27 0 0 1 .2-.08c.07 0 .14.03.2.09.05.05.07.11.07.2 0 .07-.03.13-.08.19a.27.27 0 0 1-.2.08Zm1.11 0a.27.27 0 0 1-.2-.08.27.27 0 0 1-.08-.2c0-.08.03-.14.09-.2a.27.27 0 0 1 .2-.08c.07 0 .13.03.19.09.05.05.08.11.08.2 0 .07-.03.13-.08.19a.27.27 0 0 1-.2.08Z"
          />
        </g>
        <rect
          width={66.04}
          height={6.23}
          x={167.01}
          y={65.88}
          stroke={templateStyles['border']}
          strokeWidth={0.31}
          rx={0.93}
        />
      </g>
      <path
        fill={templateStyles['icon']}
        fillRule="evenodd"
        d="M188.54 85.12v1.94h.47v-1.94h1.94v-.47h-1.94V82.7h-.47v1.95h-1.95v.47h1.95Z"
        clipRule="evenodd"
      />
      <text
        xmlSpace="preserve"
        fill={templateStyles['fontColor']}
        fontFamily={templateStyles['fontFamily']}
        fontSize={4.36}
        fontWeight={510}
        letterSpacing="0em"
        style={{
          whiteSpace: 'pre'
        }}
      >
        <tspan x={192.77} y={86.05}>
          {formatMessage(messages['templates-preview.add-entry'])}
        </tspan>
      </text>
      <rect
        width={76}
        height={95}
        x={241.04}
        y={4}
        fill={templateStyles['boardBackground']}
        rx={0.93}
      />
      <rect
        width={26.69}
        height={5.92}
        x={243.69}
        y={7.89}
        fill={tagBackgroundColors['greenLight']}
        rx={0.78}
      />
      <rect
        width={26.69}
        height={5.92}
        x={243.69}
        y={7.89}
        stroke={tagBorderColors['greenLight']}
        strokeWidth={0.31}
        rx={0.78}
      />
      <text
        xmlSpace="preserve"
        fill={templateStyles['fontColor']}
        fontFamily={templateStyles['fontFamily']}
        fontSize={4.36}
        letterSpacing="0em"
        style={{
          whiteSpace: 'pre'
        }}
      >
        <tspan x={245.8} y={12.01}>
          {formatMessage(okrTrackerMessages['okr-tracker.field-4-select-option-4'])}
        </tspan>
      </text>
      <g filter="url(#okrTracker-g)">
        <rect
          width={71.31}
          height={64.14}
          x={243.53}
          y={17.7}
          fill={templateStyles['background']}
          rx={1.25}
        />
        <text
          xmlSpace="preserve"
          fill={templateStyles['fontColor']}
          fontFamily={templateStyles['fontFamily']}
          fontSize={4.98}
          fontWeight="bold"
          letterSpacing="0em"
          style={{
            whiteSpace: 'pre'
          }}
        >
          <tspan x={246.02} y={26.32}>
            {formatMessage(okrTrackerMessages['okr-tracker.entry-4-cell-2']).substring(
              0,
              20
            )}
          </tspan>
          <tspan x={245.02} y={32.55}>
            {formatMessage(okrTrackerMessages['okr-tracker.entry-4-cell-2']).substring(
              20,
              43
            )}
          </tspan>
          <tspan x={245.02} y={38.78}>
            {formatMessage(okrTrackerMessages['okr-tracker.entry-4-cell-2']).substring(
              43
            )}
          </tspan>
        </text>
        <text
          xmlSpace="preserve"
          fill={templateStyles['fontColor']}
          fontFamily={templateStyles['fontFamily']}
          fontSize={4.36}
          letterSpacing="0em"
          style={{
            whiteSpace: 'pre'
          }}
        >
          <tspan x={246.02} y={47.59}>
            100%
          </tspan>
        </text>
        <rect
          width={26.72}
          height={8.25}
          x={246.02}
          y={52.42}
          fill={templateStyles['userBackground']}
          rx={4.12}
        />
        <path
          fill={templateStyles['icon']}
          fillRule="evenodd"
          d="M249.76 54.52a2.02 2.02 0 1 0 1.01 3.78l.24.4a2.5 2.5 0 1 1 1.25-2.16c0 .27-.1.56-.26.79a.96.96 0 0 1-.79.41.69.69 0 0 1-.66-.44c-.36.42-.94.6-1.41.32-.55-.32-.65-1.06-.32-1.62.32-.56 1.01-.85 1.56-.54.35.2.52.59.51.97v.04c0 .22.01.44.07.6.03.08.06.13.1.16.03.03.07.05.15.05a.5.5 0 0 0 .41-.23.9.9 0 0 0 .16-.5c0-1.12-.9-2.03-2.02-2.03Zm.67 1.9c0-.25-.1-.45-.28-.55-.27-.16-.7-.04-.93.36-.23.4-.12.83.15.99.27.15.7.04.93-.37a.92.92 0 0 0 .12-.4v-.03Z"
          clipRule="evenodd"
        />
        <path
          fill={templateStyles['fontColor']}
          d="M254.08 58.04v-.33h.95c.23 0 .4-.05.53-.14.12-.1.18-.23.18-.4v-.01a.5.5 0 0 0-.09-.3.5.5 0 0 0-.25-.17 1.21 1.21 0 0 0-.4-.06h-.92v-.33h.8a.9.9 0 0 0 .53-.13c.12-.08.18-.2.18-.36a.44.44 0 0 0-.16-.37.68.68 0 0 0-.45-.13h-.9v-.34h.98c.2 0 .35.03.49.1.14.06.24.15.31.26.08.12.11.25.11.4v.01a.7.7 0 0 1-.26.54.59.59 0 0 1-.27.12v.03c.14.02.27.06.37.13a.74.74 0 0 1 .32.62.8.8 0 0 1-.48.76c-.16.07-.34.1-.56.1h-1Zm-.2 0v-3.07h.4v3.07h-.4Zm2.83 0v-2.3h.37v.35h.03a.54.54 0 0 1 .23-.28c.1-.07.23-.1.39-.1h.1l.08.01v.36a1.1 1.1 0 0 0-.23-.02.67.67 0 0 0-.31.07.54.54 0 0 0-.22.2.55.55 0 0 0-.07.3v1.41h-.37Zm1.67 0v-2.3h.37v2.3h-.37Zm.18-2.73a.25.25 0 0 1-.18-.08.25.25 0 0 1-.07-.18c0-.07.02-.13.07-.18a.25.25 0 0 1 .18-.07c.07 0 .13.02.19.07.04.05.07.11.07.18a.25.25 0 0 1-.26.26Zm1.51 2.77a.9.9 0 0 1-.39-.08.67.67 0 0 1-.27-.24.64.64 0 0 1-.1-.36c0-.14.03-.25.1-.35.06-.1.16-.18.28-.23.13-.06.28-.09.46-.1l.84-.05v.3l-.8.05a.7.7 0 0 0-.38.1.32.32 0 0 0-.12.27c0 .12.04.21.13.28.09.06.2.1.33.1s.24-.03.34-.08c.1-.05.17-.12.23-.2a.52.52 0 0 0 .08-.3v-.72c0-.14-.04-.25-.13-.32-.08-.08-.21-.11-.38-.11a.68.68 0 0 0-.34.07.36.36 0 0 0-.18.2v.01h-.37a.6.6 0 0 1 .15-.32c.08-.1.19-.17.31-.22.13-.05.28-.07.44-.07.19 0 .35.03.48.09s.23.15.3.26c.06.12.1.25.1.41v1.57h-.38v-.33h-.03a.78.78 0 0 1-.4.33.92.92 0 0 1-.3.04Zm1.78-.04v-2.3h.37v.35h.03a.65.65 0 0 1 .26-.28c.1-.07.25-.1.41-.1.26 0 .46.07.6.22.14.15.2.36.2.63v1.48h-.36v-1.4c0-.2-.05-.35-.14-.45-.08-.1-.22-.15-.4-.15a.61.61 0 0 0-.32.08.54.54 0 0 0-.2.22.77.77 0 0 0-.08.35v1.35h-.37Zm3.82 0v-3.07h.38v2.73h1.48v.34h-1.86Zm2.44 0v-2.3h.37v2.3h-.37Zm.19-2.73a.25.25 0 0 1-.26-.26c0-.07.03-.13.07-.18a.25.25 0 0 1 .19-.07c.07 0 .13.02.18.07.05.05.07.11.07.18a.25.25 0 0 1-.26.26Zm.88 2.73v-2.3h.37v.35h.03a.65.65 0 0 1 .25-.28c.11-.07.25-.1.42-.1.26 0 .46.07.6.22.13.15.2.36.2.63v1.48h-.37v-1.4c0-.2-.04-.35-.13-.45-.09-.1-.22-.15-.4-.15a.61.61 0 0 0-.32.08.54.54 0 0 0-.21.22.77.77 0 0 0-.07.35v1.35h-.37Z"
        />
        <rect
          width={10.69}
          height={5.92}
          x={246.18}
          y={63.31}
          fill={tagBackgroundColors['blue']}
          rx={0.78}
        />
        <rect
          width={10.69}
          height={5.92}
          x={246.18}
          y={63.31}
          stroke={tagBorderColors['blue']}
          strokeWidth={0.31}
          rx={0.78}
        />
        <text
          xmlSpace="preserve"
          fill={templateStyles['fontColor']}
          fontFamily={templateStyles['fontFamily']}
          fontSize={4.36}
          letterSpacing="0em"
          style={{
            whiteSpace: 'pre'
          }}
        >
          <tspan x={248.48} y={67.44}>
            {formatMessage(okrTrackerMessages['okr-tracker.field-5-select-option-3'])}
          </tspan>
        </text>
        <g clipPath="url(#okrTracker-h)">
          <rect
            width={66.33}
            height={6.23}
            x={246.02}
            y={71.88}
            fill={templateStyles['background']}
            rx={0.93}
          />
          <path fill={templateStyles['background']} d="M246.96 72.81h4.36v4.36h-4.36z" />
          <path
            fill={templateStyles['link']}
            d="M248.54 74.9c-.04-.05-.11-.05-.14.01l-.7 1.41c-.01.01-.02.03-.01.04v.04l.04.03.04.01h1.03l.03-.04c.21-.44.08-1.1-.3-1.5Zm.52-1.29c-.4.63-.37 1.32-.11 1.84l.47.95c.02.03.05.04.08.04h1.02l.03-.03.01-.05a.1.1 0 0 0 0-.04l-1.36-2.7c-.03-.07-.1-.07-.14 0ZM252.64 76.88V73.8h.39v1.33h1.68V73.8h.39v3.08h-.39v-1.4h-1.68v1.4h-.39Zm4.13.04c-.21 0-.4-.05-.56-.15a.97.97 0 0 1-.36-.4 1.45 1.45 0 0 1-.13-.64c0-.25.04-.46.13-.64a.96.96 0 0 1 .92-.55c.22 0 .41.05.57.14.16.1.28.24.36.41.09.18.13.4.13.64 0 .25-.04.46-.13.63a.96.96 0 0 1-.36.41c-.16.1-.35.15-.56.15Zm0-.33c.15 0 .27-.03.37-.1.1-.07.18-.17.23-.3.06-.12.08-.28.08-.46s-.02-.34-.08-.47a.63.63 0 0 0-.23-.29.64.64 0 0 0-.37-.1.64.64 0 0 0-.36.1.63.63 0 0 0-.24.3c-.05.12-.07.28-.07.46s.02.34.07.46c.06.13.14.23.24.3.1.07.22.1.36.1Zm2 .29-.65-2.3h.37l.45 1.84h.04l.51-1.84h.35l.52 1.84h.03l.45-1.84h.37l-.64 2.3h-.38l-.5-1.78h-.04l-.51 1.78h-.37Zm3.96 0 1.13-3.08h.3v.5h-.13l-.9 2.58h-.4Zm.51-.88.12-.33h1.39l.12.33h-1.63Zm1.73.88-.9-2.58v-.5h.17l1.13 3.08h-.4Zm1.58.01c-.24 0-.4-.04-.51-.14-.1-.1-.16-.25-.16-.47v-1.4h-.36v-.3h.36v-.6h.38v.6h.5v.3h-.5v1.3c0 .14.03.24.08.3s.14.09.26.09a1.38 1.38 0 0 0 .16-.01v.31a2.35 2.35 0 0 1-.21.02Zm.79-.01v-3.2h.37v3.2h-.37Zm1.71.04a.9.9 0 0 1-.39-.09.68.68 0 0 1-.28-.23.65.65 0 0 1-.1-.36c0-.14.04-.26.1-.36.07-.1.16-.17.29-.23.12-.05.27-.09.45-.1l.84-.05v.3l-.8.05a.7.7 0 0 0-.38.1.32.32 0 0 0-.12.27c0 .12.05.21.14.28.08.06.2.1.33.1s.24-.03.33-.08a.6.6 0 0 0 .24-.2.53.53 0 0 0 .08-.3v-.71c0-.15-.04-.25-.13-.33-.08-.07-.21-.11-.38-.11a.69.69 0 0 0-.34.07.36.36 0 0 0-.18.21h-.37a.62.62 0 0 1 .15-.32.8.8 0 0 1 .31-.21c.13-.05.27-.08.44-.08.19 0 .34.03.47.1.13.05.23.14.3.26.07.11.1.25.1.4v1.58h-.37v-.34h-.03a.79.79 0 0 1-.41.33.92.92 0 0 1-.29.05Zm2.56 0c-.17 0-.32-.03-.45-.08a.8.8 0 0 1-.31-.22.6.6 0 0 1-.14-.33h.38c.03.1.1.17.18.23.1.06.21.09.36.09.1 0 .2-.02.27-.05a.47.47 0 0 0 .19-.12.28.28 0 0 0 .06-.19.25.25 0 0 0-.09-.2.73.73 0 0 0-.3-.13l-.36-.09a1.3 1.3 0 0 1-.35-.13.55.55 0 0 1-.2-.2.59.59 0 0 1-.07-.29c0-.13.03-.24.1-.34.08-.1.18-.18.31-.24s.28-.09.44-.09c.16 0 .3.03.43.08.12.05.22.12.3.21.07.1.12.2.14.33h-.37a.38.38 0 0 0-.16-.22.6.6 0 0 0-.34-.09.62.62 0 0 0-.25.04.4.4 0 0 0-.16.12.27.27 0 0 0-.07.18c0 .06.02.1.05.14.02.04.06.08.12.1.06.04.13.06.22.09l.35.08c.22.05.38.13.49.23.1.1.15.23.15.4 0 .13-.04.25-.12.36a.8.8 0 0 1-.33.24c-.13.06-.3.09-.46.09Zm2.24 0c-.17 0-.32-.03-.45-.08a.78.78 0 0 1-.31-.22.62.62 0 0 1-.14-.33h.38c.03.1.1.17.18.23.1.06.21.09.36.09.1 0 .2-.02.27-.05a.47.47 0 0 0 .19-.12.28.28 0 0 0 .06-.19.25.25 0 0 0-.09-.2.72.72 0 0 0-.3-.13l-.36-.09a1.3 1.3 0 0 1-.35-.13.54.54 0 0 1-.2-.2.59.59 0 0 1-.07-.29c0-.13.03-.24.1-.34.08-.1.18-.18.31-.24s.28-.09.44-.09c.16 0 .3.03.43.08.12.05.22.12.3.21.07.1.12.2.13.33h-.36a.37.37 0 0 0-.17-.22.6.6 0 0 0-.33-.09c-.1 0-.18.02-.25.04a.4.4 0 0 0-.16.12.28.28 0 0 0-.07.18c0 .06.02.1.05.14.02.04.06.08.12.1.06.04.13.06.22.09l.35.08c.22.05.38.13.48.23.11.1.16.23.16.4 0 .13-.04.25-.12.36a.8.8 0 0 1-.33.24c-.13.06-.3.09-.47.09Zm1.5-.04v-2.3h.38v2.3h-.37Zm.2-2.74a.25.25 0 0 1-.26-.26c0-.07.02-.13.07-.18a.25.25 0 0 1 .18-.07c.07 0 .14.02.19.07.04.05.07.11.07.18 0 .07-.03.13-.07.18a.25.25 0 0 1-.19.08Zm1.5 2.78a.9.9 0 0 1-.39-.09.67.67 0 0 1-.27-.23.65.65 0 0 1-.1-.36c0-.14.03-.26.1-.36.06-.1.16-.17.28-.23.13-.05.28-.09.46-.1l.84-.05v.3l-.8.05a.7.7 0 0 0-.38.1.32.32 0 0 0-.12.27c0 .12.04.21.13.28.09.06.2.1.33.1s.24-.03.34-.08a.6.6 0 0 0 .23-.2.53.53 0 0 0 .08-.3v-.71c0-.15-.04-.25-.13-.33-.08-.07-.21-.11-.38-.11a.69.69 0 0 0-.34.07.36.36 0 0 0-.18.21h-.37a.62.62 0 0 1 .15-.32.8.8 0 0 1 .32-.21c.12-.05.27-.08.43-.08.19 0 .35.03.48.1.13.05.23.14.3.26.06.11.1.25.1.4v1.58h-.38v-.34h-.03a.8.8 0 0 1-.18.2.73.73 0 0 1-.23.13.92.92 0 0 1-.28.05Zm1.78-.04v-2.3h.37v.35h.04a.65.65 0 0 1 .25-.29c.1-.06.25-.1.41-.1.26 0 .46.08.6.22.14.15.2.36.2.63v1.49h-.36v-1.4c0-.2-.05-.36-.14-.46-.08-.1-.22-.15-.4-.15a.62.62 0 0 0-.32.08.54.54 0 0 0-.2.22.77.77 0 0 0-.08.35v1.36h-.37Zm3.78 0v-2.3h.37v2.3h-.37Zm.19-2.74a.25.25 0 0 1-.18-.08.25.25 0 0 1-.08-.18c0-.07.03-.13.08-.18a.25.25 0 0 1 .18-.07.24.24 0 0 1 .25.26.25.25 0 0 1-.25.26Zm.88 2.74v-2.3h.37v.35h.03a.61.61 0 0 1 .24-.29.7.7 0 0 1 .38-.1c.1 0 .2.02.28.05a.69.69 0 0 1 .36.35h.03c.04-.08.1-.15.17-.2.07-.07.15-.11.24-.15.1-.03.19-.05.3-.05.15 0 .28.03.4.09.1.06.18.14.24.25.06.11.08.25.08.41v1.59h-.37v-1.5c0-.12-.01-.21-.05-.29a.35.35 0 0 0-.16-.16.56.56 0 0 0-.26-.06.5.5 0 0 0-.46.27.54.54 0 0 0-.07.26v1.48h-.38v-1.56c0-.1-.01-.17-.05-.24a.4.4 0 0 0-.17-.16.54.54 0 0 0-.25-.05c-.1 0-.2.03-.27.08a.57.57 0 0 0-.2.21.62.62 0 0 0-.06.3v1.42h-.37Zm3.8.76v-3.06h.36v.37h.04a.76.76 0 0 1 .42-.36c.09-.03.19-.05.3-.05.19 0 .36.05.5.15.14.1.26.24.34.41.08.18.12.39.12.63s-.04.45-.12.63a.95.95 0 0 1-.34.41.88.88 0 0 1-.5.15.86.86 0 0 1-.55-.19.7.7 0 0 1-.17-.22h-.04v1.13h-.37Zm1.03-1.05c.14 0 .26-.03.36-.1.1-.07.17-.17.23-.3.05-.13.08-.28.08-.46s-.03-.34-.08-.46a.65.65 0 0 0-.23-.3.61.61 0 0 0-.36-.1.62.62 0 0 0-.36.1.67.67 0 0 0-.23.3c-.06.13-.09.28-.09.46s.03.33.09.46c.05.13.13.23.23.3.1.06.22.1.36.1Zm1.65.29v-3.2h.37v3.2h-.37Zm2.01.04c-.22 0-.4-.05-.56-.15a.96.96 0 0 1-.36-.4 1.45 1.45 0 0 1-.13-.63c0-.24.04-.45.13-.63a1 1 0 0 1 .36-.42c.15-.1.33-.15.54-.15a.93.93 0 0 1 .88.55c.08.17.12.37.12.6v.15h-1.84v-.3h1.65l-.18.27v-.15c0-.18-.03-.33-.08-.44a.57.57 0 0 0-.55-.35.62.62 0 0 0-.33.1.62.62 0 0 0-.23.26 1 1 0 0 0-.09.43v.15c0 .16.03.3.08.42a.62.62 0 0 0 .6.36c.1 0 .2-.02.27-.05a.6.6 0 0 0 .2-.1.4.4 0 0 0 .1-.14v-.02h.38v.02a.7.7 0 0 1-.12.23.87.87 0 0 1-.47.34c-.11.03-.23.05-.37.05Zm1.56-.04v-2.3h.37v.35h.03a.61.61 0 0 1 .24-.29.7.7 0 0 1 .38-.1c.1 0 .2.02.28.05.08.04.15.08.21.15.06.05.11.12.15.2h.03c.04-.08.1-.15.17-.2.07-.07.15-.11.24-.15.09-.03.19-.05.3-.05.15 0 .28.03.39.09.1.06.2.14.25.25.05.11.08.25.08.41v1.59h-.37v-1.5c0-.12-.02-.21-.05-.29a.34.34 0 0 0-.16-.16.56.56 0 0 0-.27-.06c-.1 0-.2.02-.28.07a.5.5 0 0 0-.18.2.54.54 0 0 0-.07.26v1.48h-.37v-1.56c0-.1-.02-.17-.06-.24a.38.38 0 0 0-.16-.16.54.54 0 0 0-.25-.05c-.1 0-.2.03-.27.08a.56.56 0 0 0-.2.21.64.64 0 0 0-.06.3v1.42h-.37Zm4.73.04c-.22 0-.4-.05-.57-.15a.95.95 0 0 1-.36-.4 1.45 1.45 0 0 1-.12-.63c0-.24.04-.45.12-.63a1 1 0 0 1 .36-.42c.16-.1.34-.15.54-.15a.93.93 0 0 1 .88.55c.09.17.13.37.13.6v.15h-1.84v-.3h1.65l-.19.27v-.15c0-.18-.02-.33-.08-.44a.57.57 0 0 0-.22-.26.61.61 0 0 0-.33-.09.62.62 0 0 0-.33.1.62.62 0 0 0-.23.26 1 1 0 0 0-.08.43v.15c0 .16.02.3.08.42a.62.62 0 0 0 .6.36c.1 0 .19-.02.27-.05a.6.6 0 0 0 .19-.1.4.4 0 0 0 .1-.14v-.02h.38v.02a.7.7 0 0 1-.11.23.87.87 0 0 1-.48.34c-.1.03-.23.05-.36.05Zm1.55-.04v-2.3h.37v.35h.04a.65.65 0 0 1 .25-.29c.1-.06.25-.1.41-.1.26 0 .46.08.6.22.14.15.2.36.2.63v1.49h-.36v-1.4c0-.2-.05-.36-.13-.46-.1-.1-.23-.15-.41-.15a.61.61 0 0 0-.32.08.54.54 0 0 0-.2.22.77.77 0 0 0-.08.35v1.36h-.37Zm3.36.01c-.23 0-.4-.04-.51-.14-.1-.1-.16-.25-.16-.47v-1.4h-.36v-.3h.36v-.6h.38v.6h.5v.3h-.5v1.3c0 .14.03.24.08.3s.14.09.26.09a1.4 1.4 0 0 0 .17-.01v.31a2.62 2.62 0 0 1-.22.02Zm1.68.03c-.22 0-.4-.05-.57-.15a.96.96 0 0 1-.36-.4 1.45 1.45 0 0 1-.12-.63c0-.24.04-.45.12-.63a1 1 0 0 1 .36-.42c.16-.1.34-.15.54-.15a.92.92 0 0 1 .88.55c.09.17.13.37.13.6v.15h-1.84v-.3h1.65l-.19.27v-.15c0-.18-.02-.33-.08-.44a.57.57 0 0 0-.22-.26.61.61 0 0 0-.33-.09.61.61 0 0 0-.33.1.6.6 0 0 0-.23.26 1 1 0 0 0-.08.43v.15c0 .16.02.3.08.42.05.11.13.2.24.27.1.06.22.09.36.09.1 0 .19-.02.27-.05a.58.58 0 0 0 .19-.1.4.4 0 0 0 .1-.14v-.02h.38v.02a.69.69 0 0 1-.11.23.85.85 0 0 1-.2.2.99.99 0 0 1-.28.14c-.1.03-.23.05-.36.05Zm1.85-.02a.27.27 0 0 1-.2-.08.27.27 0 0 1-.07-.2c0-.08.02-.14.08-.2a.27.27 0 0 1 .2-.08c.07 0 .14.03.19.09.05.05.08.11.08.2 0 .07-.03.13-.08.19a.27.27 0 0 1-.2.08Zm1.11 0a.27.27 0 0 1-.27-.28c0-.08.02-.14.07-.2a.27.27 0 0 1 .2-.08c.08 0 .14.03.2.09.05.05.08.11.08.2 0 .07-.03.13-.08.19a.27.27 0 0 1-.2.08Zm1.1 0a.27.27 0 0 1-.19-.08.27.27 0 0 1-.08-.2c0-.08.03-.14.08-.2a.27.27 0 0 1 .2-.08c.07 0 .14.03.2.09.05.05.07.11.07.2 0 .07-.02.13-.08.19a.27.27 0 0 1-.2.08Z"
          />
        </g>
        <rect
          width={66.33}
          height={6.23}
          x={246.02}
          y={71.88}
          stroke={templateStyles['border']}
          strokeWidth={0.31}
          rx={0.93}
        />
      </g>
      <path
        fill={templateStyles['icon']}
        fillRule="evenodd"
        d="M267.7 91.12v1.94h.47v-1.94h1.94v-.47h-1.94V88.7h-.47v1.95h-1.94v.47h1.94Z"
        clipRule="evenodd"
      />
      <text
        xmlSpace="preserve"
        fill={templateStyles['fontColor']}
        fontFamily={templateStyles['fontFamily']}
        fontSize={4.36}
        fontWeight={510}
        letterSpacing="0em"
        style={{
          whiteSpace: 'pre'
        }}
      >
        <tspan x={271.93} y={92.05}>
          {formatMessage(messages['templates-preview.add-entry'])}
        </tspan>
      </text>
      <path
        fill={templateStyles['boardBackground']}
        d="M319.5 4.93c0-.51.4-.93.93-.93H331c.52 0 .94.42.94.93v10.28c0 .52-.42.93-.94.93h-10.58a.93.93 0 0 1-.94-.93V4.93Z"
      />
      <path
        fill={templateStyles['background']}
        fillOpacity={0.01}
        d="M321.98 6.34h7.47v7.47h-7.47z"
      />
      <path
        fill={templateStyles['icon']}
        d="M325.72 7.58c.16 0 .3.12.3.28l.01.03v1.87h1.87a.31.31 0 0 1 .04.62h-1.92v1.87a.31.31 0 0 1-.62.04v-1.91h-1.87a.31.31 0 0 1-.04-.62h1.92V7.9c0-.17.14-.3.3-.3Z"
      />
      <defs>
        <clipPath id="okrTracker-b">
          <rect
            width={66.04}
            height={6.23}
            x={8.98}
            y={71.88}
            fill={templateStyles['background']}
            rx={0.93}
          />
        </clipPath>
        <clipPath id="okrTracker-d">
          <rect
            width={66.04}
            height={6.23}
            x={88}
            y={65.88}
            fill={templateStyles['background']}
            rx={0.93}
          />
        </clipPath>
        <clipPath id="okrTracker-f">
          <rect
            width={66.04}
            height={6.23}
            x={167.01}
            y={65.88}
            fill={templateStyles['background']}
            rx={0.93}
          />
        </clipPath>
        <clipPath id="okrTracker-h">
          <rect
            width={66.33}
            height={6.23}
            x={246.02}
            y={71.88}
            fill={templateStyles['background']}
            rx={0.93}
          />
        </clipPath>
        <filter
          id="okrTracker-a"
          width={71.77}
          height={65.27}
          x={6.11}
          y={17.32}
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset dy={0.38} />
          <feGaussianBlur stdDeviation={0.19} />
          <feColorMatrix values="0 0 0 0 0.0352941 0 0 0 0 0.117647 0 0 0 0 0.258824 0 0 0 0.25 0" />
          <feBlend in2="BackgroundImageFix" result="effect1_dropShadow_1228_19922" />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset />
          <feGaussianBlur stdDeviation={0.19} />
          <feColorMatrix values="0 0 0 0 0.0352941 0 0 0 0 0.117647 0 0 0 0 0.258824 0 0 0 0.31 0" />
          <feBlend
            in2="effect1_dropShadow_1228_19922"
            result="effect2_dropShadow_1228_19922"
          />
          <feBlend
            in="SourceGraphic"
            in2="effect2_dropShadow_1228_19922"
            result="shape"
          />
        </filter>
        <filter
          id="okrTracker-c"
          width={71.77}
          height={59.27}
          x={85.13}
          y={17.32}
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset dy={0.38} />
          <feGaussianBlur stdDeviation={0.19} />
          <feColorMatrix values="0 0 0 0 0.0352941 0 0 0 0 0.117647 0 0 0 0 0.258824 0 0 0 0.25 0" />
          <feBlend in2="BackgroundImageFix" result="effect1_dropShadow_1228_19922" />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset />
          <feGaussianBlur stdDeviation={0.19} />
          <feColorMatrix values="0 0 0 0 0.0352941 0 0 0 0 0.117647 0 0 0 0 0.258824 0 0 0 0.31 0" />
          <feBlend
            in2="effect1_dropShadow_1228_19922"
            result="effect2_dropShadow_1228_19922"
          />
          <feBlend
            in="SourceGraphic"
            in2="effect2_dropShadow_1228_19922"
            result="shape"
          />
        </filter>
        <filter
          id="okrTracker-e"
          width={71.77}
          height={59.27}
          x={164.14}
          y={17.32}
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset dy={0.38} />
          <feGaussianBlur stdDeviation={0.19} />
          <feColorMatrix values="0 0 0 0 0.0352941 0 0 0 0 0.117647 0 0 0 0 0.258824 0 0 0 0.25 0" />
          <feBlend in2="BackgroundImageFix" result="effect1_dropShadow_1228_19922" />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset />
          <feGaussianBlur stdDeviation={0.19} />
          <feColorMatrix values="0 0 0 0 0.0352941 0 0 0 0 0.117647 0 0 0 0 0.258824 0 0 0 0.31 0" />
          <feBlend
            in2="effect1_dropShadow_1228_19922"
            result="effect2_dropShadow_1228_19922"
          />
          <feBlend
            in="SourceGraphic"
            in2="effect2_dropShadow_1228_19922"
            result="shape"
          />
        </filter>
        <filter
          id="okrTracker-g"
          width={72.06}
          height={65.27}
          x={243.16}
          y={17.32}
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset dy={0.38} />
          <feGaussianBlur stdDeviation={0.19} />
          <feColorMatrix values="0 0 0 0 0.0352941 0 0 0 0 0.117647 0 0 0 0 0.258824 0 0 0 0.25 0" />
          <feBlend in2="BackgroundImageFix" result="effect1_dropShadow_1228_19922" />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset />
          <feGaussianBlur stdDeviation={0.19} />
          <feColorMatrix values="0 0 0 0 0.0352941 0 0 0 0 0.117647 0 0 0 0 0.258824 0 0 0 0.31 0" />
          <feBlend
            in2="effect1_dropShadow_1228_19922"
            result="effect2_dropShadow_1228_19922"
          />
          <feBlend
            in="SourceGraphic"
            in2="effect2_dropShadow_1228_19922"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  );
};
export default OkrTracker;
